import React, { useState, useEffect, useRef, useCallback } from 'react';
import { useAuth } from '../module_roots/AuthContext';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
    faBox,
    faBarcode,
    faTag,
    faBuilding,
    faBalanceScale,
    faRupeeSign,
    faCalculator,
    faExclamationTriangle,
    faCalendarAlt,
    faSave,
    faTimes,
    faCheckCircle,
    faStore,
    faExchangeAlt,
    faWarehouse,
    faPercent,
    faQrcode,
    faBoxes,
    faLayerGroup,
    faCubes,
    faFileAlt,
    faSpinner,
    faChevronDown
} from '@fortawesome/free-solid-svg-icons';
// import "./Styles/Form.css";

// Create translator instance with Urdu translations
const createProductsTranslator = () => {
    let cache = new Map();

    // Predefined translations for Urdu
    const urduTranslations = {
        addProduct: 'محفوظ کریں',
        editProduct: 'ترمیم کریں',
        fillDetails: 'براہ کرم تفصیلات درج کریں',
        productDetails: 'مصنوعات کی تفصیلات',
        productName: 'مصنوعات کا نام',
        productCode: 'مصنوعات کا کوڈ',
        batchNumber: 'بیچ نمبر',
        barcode: 'بارکوڈ',
        category: 'زمرہ',
        company: 'کمپنی / برانڈ',
        color: 'رنگ',
        size: 'سائز',
        unit: 'یونٹ',
        costPrice: 'لاگت قیمت',
        sellingPrice: 'فروخت قیمت',
        quantity: 'مقدار',
        quantityAlert: 'کم اسٹاک الرٹ',
        expiryDate: 'میعاد ختم ہونے کی تاریخ',
        date: 'تاریخ',
        addProductButton: 'محفوظ کریں',
        updateProduct: 'اپ ڈیٹ کریں',
        clearButton: 'صاف کریں',
        adding: 'محفوظ ہو رہا ہے...',
        updating: 'اپ ڈیٹ ہو رہا ہے...',
        productSaved: 'مصنوعات کامیابی سے محفوظ ہو گئی!',
        productUpdated: 'مصنوعات کامیابی سے اپ ڈیٹ ہو گئی!',
        failedAdd: 'مصنوعات محفوظ کرنے میں ناکامی',
        failedUpdate: 'مصنوعات اپ ڈیٹ کرنے میں ناکامی',
        networkError: 'نیٹ ورک کی خرابی',
        nameRequired: 'مصنوعات کا نام ضروری ہے',
        nameTooShort: 'نام کم از کم 2 حروف کا ہونا چاہیے',
        batchRequired: 'بیچ نمبر ضروری ہے',
        batchExists: 'یہ بیچ نمبر پہلے سے موجود ہے',
        productCodeExists: 'یہ مصنوعات کا کوڈ پہلے سے موجود ہے',
        unitRequired: 'یونٹ ضروری ہے',
        costPriceRequired: 'لاگت قیمت ضروری ہے',
        sellingPriceRequired: 'فروخت قیمت ضروری ہے',
        quantityRequired: 'مقدار ضروری ہے',
        alertRequired: 'کم اسٹاک الرٹ ضروری ہے',
        invalidPrice: 'براہ کرم درست قیمت درج کریں',
        invalidQuantity: 'براہ کرم درست مقدار درج کریں',
        expiryPast: 'میعاد ختم ہونے کی تاریخ ماضی میں نہیں ہو سکتی',
        success: 'کامیابی',
        error: 'خرابی',
        warning: 'انتباہ',
        selectShop: 'پہلے دکان منتخب کریں',
        currentShop: 'موجودہ دکان',
        willAddToShop: 'مصنوعات اس دکان میں شامل ہو گی',
        noShopSelected: 'کوئی دکان منتخب نہیں۔ براہ کرم پہلے دکان تبدیل کریں',
        switchShop: 'دکان تبدیل کریں',
        shopSwitched: 'دکان کامیابی سے تبدیل ہو گئی',
        shopSwitchFailed: 'دکان تبدیل کرنے میں ناکامی',
        loadingShops: 'دکانیں لوڈ ہو رہی ہیں...',
        noShops: 'کوئی دکان دستیاب نہیں',
        active: 'فعال',
        current: 'موجودہ',
        profitMargin: 'منافع کا مارجن',
        markup: 'مارک اپ',
        selectCategory: 'زمرہ منتخب کریں',
        selectUnit: 'یونٹ منتخب کریں',
        optional: 'اختیاری',
        enterProductName: 'مصنوعات کا نام درج کریں',
        enterProductCode: 'مصنوعات کا کوڈ درج کریں',
        enterBatchNumber: 'بیچ نمبر درج کریں (اختیاری)',
        barcodeAutoGenerate: 'بارکوڈ خودکار جنریٹ ہو گا',
        enterCompany: 'کمپنی/برانڈ درج کریں',
        zeroPlaceholder: '0.0',
        zeroPlaceholderDecimal: '0.00',
        zeroPlaceholderThreeDecimal: '0.000',
        packingType: 'پیکنگ کی قسم',
        subPackingType: 'ذیلی پیکنگ کی قسم',
        itemsPerPack: 'فی پیک اشیاء',
        unitOfMeasure: 'پیمائش کی اکائی',
        totalQuantity: 'کل مقدار',
        costPerPack: 'فی پیک لاگت',
        sellingPerPack: 'فی پیک فروخت قیمت',
        selectPackingType: 'پیکنگ کی قسم منتخب کریں',
        enterItemsPerPack: 'فی پیک اشیاء کی تعداد درج کریں',
        costPerUnit: 'فی یونٹ لاگت',
        sellPricePerUnit: 'فی یونٹ فروخت قیمت',
        bquantity: 'کل مقدار (بلک)',
        box: 'باکس',
        carton: 'کارٹن',
        crate: 'کریٹ',
        packet: 'پیکٹ',
        bundle: 'بنڈل',
        bottle: 'بوتل',
        can: 'کین',
        piece: 'ٹکڑا',
        '1_liter': '1 لیٹر',
        '2_liter': '2 لیٹر',
        '3_liter': '3 لیٹر',
        '5_liter': '5 لیٹر',
        draftLoaded: 'ڈرافٹ لوڈ ہو گیا',
        draftCleared: 'ڈرافٹ صاف کر دیا گیا',
        draftExists: 'پہلے سے محفوظ ڈرافٹ موجود ہے',
        batchAutoGenerated: 'بیچ نمبر خودکار جنریٹ ہو گیا: '
    };

    const defaultTexts = {
        addProduct: 'Add Product',
        editProduct: 'Edit Stock',
        fillDetails: 'Fill in the stock details below',
        productDetails: 'Product Details',
        productName: 'Product Name',
        productCode: 'Product Code / Grade',
        batchNumber: 'Batch Number',
        barcode: 'Barcode',
        category: 'Category',
        company: 'Company / Brand',
        color: 'Color',
        size: 'Size',
        unit: 'Unit',
        costPrice: 'Cost Price',
        sellingPrice: 'Selling Price',
        quantity: 'Quantity',
        quantityAlert: 'Low Stock Alert',
        expiryDate: 'Expiry Date',
        date: 'Date',
        addProductButton: 'Save Product',
        updateProduct: 'Update Product',
        clearButton: 'Clear',
        adding: 'Adding...',
        updating: 'Updating...',
        productSaved: 'Product saved successfully!',
        productUpdated: 'Product updated successfully!',
        failedAdd: 'Failed to save product',
        failedUpdate: 'Failed to update product',
        networkError: 'Network error occurred',
        nameRequired: 'Product name is required',
        nameTooShort: 'Name must be at least 2 characters',
        batchRequired: 'Batch number is required',
        batchExists: 'This batch number already exists',
        productCodeExists: 'This product code already exists',
        unitRequired: 'Unit is required',
        costPriceRequired: 'Cost price is required',
        sellingPriceRequired: 'Selling price is required',
        quantityRequired: 'Quantity is required',
        alertRequired: 'Low stock alert quantity is required',
        invalidPrice: 'Please enter a valid price',
        invalidQuantity: 'Please enter a valid quantity',
        expiryPast: 'Expiry date cannot be in the past',
        success: 'Success',
        error: 'Error',
        warning: 'Warning',
        selectShop: 'Select a shop first',
        currentShop: 'Current Shop',
        willAddToShop: 'Product will be added to this shop',
        noShopSelected: 'No shop selected. Please switch to a shop first.',
        switchShop: 'Switch Shop',
        shopSwitched: 'Shop switched successfully',
        shopSwitchFailed: 'Failed to switch shop',
        loadingShops: 'Loading shops...',
        noShops: 'No shops available',
        active: 'Active',
        current: 'Current',
        profitMargin: 'Profit Margin',
        markup: 'Markup',
        selectCategory: 'Select category',
        selectUnit: 'Select unit',
        optional: 'Optional',
        enterProductName: 'Enter product name',
        enterProductCode: 'Enter product code',
        enterBatchNumber: 'Enter batch number (optional)',
        barcodeAutoGenerate: 'Barcode will auto-generate',
        enterCompany: 'Enter company/brand',
        zeroPlaceholder: '0.0',
        zeroPlaceholderDecimal: '0.00',
        zeroPlaceholderThreeDecimal: '0.000',
        packingType: 'Packing Type',
        subPackingType: 'Sub Packing Type',
        itemsPerPack: 'Items Per',
        unitOfMeasure: 'Unit of Measure',
        totalQuantity: 'Total Quantity',
        costPerPack: 'Cost Per',
        sellingPerPack: 'Selling Price Per',
        selectPackingType: 'Select packing type',
        enterItemsPerPack: 'Enter items per pack',
        costPerUnit: 'Cost per',
        sellPricePerUnit: 'Sell price per',
        bquantity: 'BQuantity',
        box: 'Box',
        carton: 'Carton',
        crate: 'Crate',
        packet: 'Packet',
        bundle: 'Bundle',
        bottle: 'Bottle',
        can: 'Can',
        piece: 'Piece',
        '1_liter': '1 Liter',
        '2_liter': '2 Liters',
        '3_liter': '3 Liters',
        '5_liter': '5 Liters',
        draftLoaded: 'Draft loaded',
        draftCleared: 'Draft cleared',
        draftExists: 'A saved draft exists',
        batchAutoGenerated: 'Batch number auto-generated: '
    };

    const getTranslations = async (lang) => {
        if (lang === 'en') return defaultTexts;
        if (lang === 'ur') return urduTranslations;
        return defaultTexts;
    };

    return { getTranslations };
};

const productsTranslator = createProductsTranslator();

// Helper function to generate batch number from product name - UPDATED to 6 characters
const generateBatchNoFromProductName = (productName) => {
    if (!productName || productName.trim() === '') {
        return '';
    }
    
    // Clean the product name: remove special characters, convert to uppercase
    let cleanName = productName.trim().toUpperCase();
    
    // Remove any special characters that might cause issues
    cleanName = cleanName.replace(/[^A-Z0-9]/g, '');
    
    // If product name is too short, pad with 'X'
    if (cleanName.length === 0) {
        cleanName = 'XXX';
    } else if (cleanName.length === 1) {
        cleanName = cleanName + 'XX';
    } else if (cleanName.length === 2) {
        cleanName = cleanName + 'X';
    }
    
    // Take FIRST letter
    const firstLetter = cleanName.charAt(0);
    
    // Take MIDDLE letter (if odd length, take the middle character)
    let middleLetter;
    if (cleanName.length === 1) {
        middleLetter = firstLetter;
    } else if (cleanName.length === 2) {
        middleLetter = cleanName.charAt(1);
    } else {
        const middleIndex = Math.floor((cleanName.length - 1) / 2);
        middleLetter = cleanName.charAt(middleIndex);
    }
    
    // Take LAST letter
    const lastLetter = cleanName.charAt(cleanName.length - 1);
    
    // Combine to get 3 letters from product name
    const namePart = `${firstLetter}${middleLetter}${lastLetter}`;
    
    // Generate 3 random alphanumeric characters
    const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789';
    let randomPart = '';
    for (let i = 0; i < 3; i++) {
        randomPart += chars.charAt(Math.floor(Math.random() * chars.length));
    }
    
    // Combine name part (3 letters) + random part (3 alphanumeric) = total 6 characters
    const batchNo = `${namePart}${randomPart}`;
    
    return batchNo;
};

// Request deduplication helper
const requestTracker = new Map();

function isDuplicateRequest(requestData) {
    const key = JSON.stringify({
        action: requestData.action,
        product_name: requestData.product_name,
        batch_no: requestData.batch_no,
        product_code: requestData.product_code,
        shop_id: requestData.shop_id
    });

    const now = Date.now();
    const lastRequest = requestTracker.get(key);

    if (lastRequest && (now - lastRequest) < 5000) {
        return true;
    }

    requestTracker.set(key, now);

    for (const [k, time] of requestTracker.entries()) {
        if (now - time > 10000) {
            requestTracker.delete(k);
        }
    }

    return false;
}

// Helper function to get packing type display name
const getPackingTypeDisplayName = (packingType) => {
    if (!packingType) return 'Pack';
    const packingTypeMap = {
        box: 'Box',
        carton: 'Carton',
        crate: 'Crate',
        packet: 'Packet',
        bundle: 'Bundle',
        bottle: 'Bottle',
        can: 'Can'
    };
    return packingTypeMap[packingType] || 'Pack';
};

// Helper function to get plural form of packing type
const getPluralPackingName = (packingType) => {
    if (!packingType) return 'Packs';
    const pluralMap = {
        box: 'Boxes',
        carton: 'Cartons',
        crate: 'Crates',
        packet: 'Packets',
        bundle: 'Bundles',
        bottle: 'Bottles',
        can: 'Cans'
    };
    return pluralMap[packingType] || 'Packs';
};

// Toast Notification Component
const ToastNotification = ({ toast, setToast, translations }) => {
    const getIconForType = (type) => {
        switch (type) {
            case 'success':
                return faCheckCircle;
            case 'error':
                return faExclamationTriangle;
            case 'warning':
                return faExclamationTriangle;
            case 'info':
                return faCheckCircle;
            default:
                return faCheckCircle;
        }
    };

    const getTitleForType = (type) => {
        switch (type) {
            case 'success':
                return translations.success || 'Success';
            case 'error':
                return translations.error || 'Error';
            case 'warning':
                return translations.warning || 'Warning';
            case 'info':
                return 'Info';
            default:
                return '';
        }
    };

    if (!toast.show) return null;

    return (
        <div className={`ozui_toast-notification ${toast.type}`}>
            <div className="ozui_toast-content">
                <div className="ozui_toast-icon">
                    <FontAwesomeIcon icon={getIconForType(toast.type)} />
                </div>
                <div className="ozui_toast-text">
                    <div className="ozui_toast-title">{getTitleForType(toast.type)}</div>
                    <div className="ozui_toast-message">{toast.message}</div>
                </div>
                <button className="ozui_toast-close" onClick={() => setToast(prev => ({ ...prev, show: false }))}>
                    <FontAwesomeIcon icon={faTimes} />
                </button>
            </div>
        </div>
    );
};

// Shop Selector Modal Component
const ShopSelectorModal = ({ isOpen, onClose, shops, currentShop, onSelectShop, translations, loading }) => {
    if (!isOpen) return null;

    return (
        <div className="ozui_modal-overlay" onClick={onClose}>
            <div className="ozui_modal" onClick={e => e.stopPropagation()}>
                <div className="ozui_modal-header">
                    <h3>{translations.switchShop || 'Switch Shop'}</h3>
                    <button className="ozui_modal-close" onClick={onClose}>
                        <FontAwesomeIcon icon={faTimes} />
                    </button>
                </div>
                <div className="ozui_modal-body">
                    {loading ? (
                        <div className="ozui_loading-state">{translations.loadingShops || 'Loading shops...'}</div>
                    ) : shops.length === 0 ? (
                        <div className="ozui_empty-state">{translations.noShops || 'No shops available'}</div>
                    ) : (
                        shops.map((shop) => (
                            <div 
                                key={shop.shop_id}
                                className={`ozui_shop-item ${currentShop?.shop_id === shop.shop_id ? 'ozui_active' : ''}`}
                                onClick={() => onSelectShop(shop)}
                            >
                                <div className="ozui_shop-info">
                                    <div className="ozui_shop-name">{shop.shop_name}</div>
                                    <div className="ozui_shop-code">{shop.shop_code || `ID: ${shop.shop_id}`}</div>
                                </div>
                                {currentShop?.shop_id === shop.shop_id && (
                                    <div className="ozui_shop-badge">✓ {translations.current || 'Current'}</div>
                                )}
                            </div>
                        ))
                    )}
                </div>
            </div>
        </div>
    );
};

const HardwareProduct = ({ productId = null, onSuccess = null }) => {
    const { user, currentShop, switchShop, getShopsForSwitch } = useAuth();

    const [currentLanguage, setCurrentLanguage] = useState(() => {
        return user?.language || localStorage.getItem('ourzest_language') || 'en';
    });

    // Auto-focus ref for Product Name field (first text input after date)
    const productNameRef = useRef(null);

    // Tab key handler to close all dropdowns
    useEffect(() => {
        const handleTabKey = (e) => {
            if (e.key === 'Tab') {
                // Close all dropdowns when Tab is pressed
                setShowCategoryDropdown(false);
                setShowPackingTypeDropdown(false);
                setShowSubPackingDropdown(false);
                setShowUnitDropdown(false);
                setShowColorDropdown(false);
                setShowSizeDropdown(false);
            }
        };
        
        document.addEventListener('keydown', handleTabKey);
        return () => document.removeEventListener('keydown', handleTabKey);
    }, []);

    // Auto-focus on Product Name field when component mounts
    useEffect(() => {
        // Small delay to ensure DOM is ready
        setTimeout(() => {
            if (productNameRef.current) {
                productNameRef.current.focus();
            }
        }, 100);
    }, []);

    // Packaging types configuration
    const packingTypes = [
        { value: '', label: 'selectPackingType' },
        { value: 'box', label: 'box', icon: faBox },
        { value: 'packet', label: 'packet', icon: faLayerGroup },
        { value: 'bundle', label: 'bundle', icon: faLayerGroup }
    ];
    
    const subPackingTypes = {
        Default:
        { value: '', label: 'selectsubPackingType' },

        box: [
            { value: 'bottles', label: 'Bottles', defaultUnit: '1_liter', defaultQty: 24 },
            { value: 'pieces', label: 'Pieces', defaultUnit: 'piece', defaultQty: 50 },
            { value: 'cans', label: 'Cans', defaultUnit: 'can', defaultQty: 12 },
            { value: 'packs', label: 'Packs', defaultUnit: 'packet', defaultQty: 10 }
        ],
        carton: [
            { value: 'boxes', label: 'Boxes', defaultUnit: 'box', defaultQty: 6 },
            { value: 'pieces', label: 'Pieces', defaultUnit: 'piece', defaultQty: 100 },
            { value: 'bottles', label: 'Bottles', defaultUnit: '1_liter', defaultQty: 48 }
        ],
        crate: [
            { value: 'bottles', label: 'Bottles', defaultUnit: '1_liter', defaultQty: 12 },
            { value: 'cans', label: 'Cans', defaultUnit: 'can', defaultQty: 24 },
            { value: 'pieces', label: 'Pieces', defaultUnit: 'piece', defaultQty: 30 }
        ],
        packet: [
            { value: 'pieces', label: 'Pieces', defaultUnit: 'piece', defaultQty: 20 },
            { value: 'grams', label: 'Grams', defaultUnit: 'gram', defaultQty: 500 }
        ],
        bundle: [
            { value: 'pieces', label: 'Pieces', defaultUnit: 'piece', defaultQty: 100 },
            { value: 'dozen', label: 'Dozen', defaultUnit: 'dozen', defaultQty: 10 }
        ],
        bottle: [
            { value: 'pieces', label: 'Pieces', defaultUnit: 'piece', defaultQty: 1 },
            { value: 'liters', label: 'Liters', defaultUnit: '1_liter', defaultQty: 1 }
        ],
        can: [
            { value: 'pieces', label: 'Pieces', defaultUnit: 'piece', defaultQty: 1 },
            { value: 'liters', label: 'Liters', defaultUnit: '1_liter', defaultQty: 1 }
        ]
    };

    // UPDATED: Units of measure with ALL NEW UNITS
    const unitsOfMeasure = [
        { value: '', label: 'Select Unit' },
        // Liter options
        { value: '1_liter', label: '1 Liter (1L)', numericValue: 1 },
        { value: '2_liter', label: '2 Liters (2L)', numericValue: 2 },
        { value: '3_liter', label: '3 Liters (3L)', numericValue: 3 },
        { value: '5_liter', label: '5 Liters (5L)', numericValue: 5 },
        // NEW: ml units
        { value: '200_ml', label: '200 ml', numericValue: 0.2 },
        { value: '250_ml', label: '250 ml', numericValue: 0.25 },
        { value: '300_ml', label: '300 ml', numericValue: 0.3 },
        { value: '350_ml', label: '350 ml', numericValue: 0.35 },
        { value: '400_ml', label: '400 ml', numericValue: 0.4 },
        { value: '450_ml', label: '450 ml', numericValue: 0.45 },
        { value: '500_ml', label: '500 ml', numericValue: 0.5 },
        // NEW: liter units (0.5, 0.7, 1-7, 10, 20, 60, 208)
        { value: '0.5_liter', label: '0.5 Liter', numericValue: 0.5 },
        { value: '0.7_liter', label: '0.7 Liter', numericValue: 0.7 },
        { value: '1_liter_alt', label: '1 Liter', numericValue: 1 },
        { value: '2_liter_alt', label: '2 Liters', numericValue: 2 },
        { value: '3_liter_alt', label: '3 Liters', numericValue: 3 },
        { value: '4_liter', label: '4 Liters', numericValue: 4 },
        { value: '5_liter_alt', label: '5 Liters', numericValue: 5 },
        { value: '6_liter', label: '6 Liters', numericValue: 6 },
        { value: '7_liter', label: '7 Liters', numericValue: 7 },
        { value: '10_liter', label: '10 Liters', numericValue: 10 },
        { value: '20_liter', label: '20 Liters', numericValue: 20 },
        { value: '60_liter', label: '60 Liters', numericValue: 60 },
        { value: '208_liter', label: '208 Liters', numericValue: 208 },
        // Other units
        { value: 'milliliter', label: 'Milliliter (ml)', numericValue: 0.001 },
        { value: 'kilogram', label: 'Kilogram (kg)', numericValue: 1 },
        { value: 'gram', label: 'Gram (g)', numericValue: 0.001 },
        { value: 'piece', label: 'Piece (pc)', numericValue: 1 },
        { value: 'dozen', label: 'Dozen (dz)', numericValue: 12 },
        { value: 'box', label: 'Box', numericValue: 1 },
        { value: 'packet', label: 'Packet', numericValue: 1 },
        { value: 'can', label: 'Can', numericValue: 1 },
        { value: 'bottle', label: 'Bottle', numericValue: 1 }
    ];

    // Category options
    const categoryOptions = [
        { value: '', label: 'Select Category' },
        { value: 'suzuki_alto', label: 'Suzuki Alto' },
        { value: 'suzuki_swift', label: 'Suzuki Swift' },
        { value: 'suzuki_cultus', label: 'Suzuki Cultus' },
        { value: 'suzuki_wagon_r', label: 'Suzuki Wagon R' },
        { value: 'suzuki_bolan', label: 'Suzuki Bolan' },
        { value: 'suzuki_mehran', label: 'Suzuki Mehran' },
        { value: 'suzuki_every', label: 'Suzuki Every' },
        { value: 'suzuki_ravi', label: 'Suzuki Ravi' },
        { value: 'suzuki_apv', label: 'Suzuki APV' },
        { value: 'suzuki_carry', label: 'Suzuki Carry' },
        { value: 'toyota_corolla', label: 'Toyota Corolla' },
        { value: 'toyota_yaris', label: 'Toyota Yaris' },
        { value: 'toyota_camry', label: 'Toyota Camry' },
        { value: 'toyota_fortuner', label: 'Toyota Fortuner' },
        { value: 'toyota_land_cruiser', label: 'Toyota Land Cruiser' },
        { value: 'toyota_hilux', label: 'Toyota Hilux' },
        { value: 'honda_civic', label: 'Honda Civic' },
        { value: 'honda_city', label: 'Honda City' },
        { value: 'honda_accord', label: 'Honda Accord' },
        { value: 'hyundai_santro', label: 'Hyundai Santro' },
        { value: 'hyundai_elantra', label: 'Hyundai Elantra' },
        { value: 'hyundai_tucson', label: 'Hyundai Tucson' },
        { value: 'kia_picanto', label: 'Kia Picanto' },
        { value: 'kia_sportage', label: 'Kia Sportage' },
        { value: 'nissan_dayz', label: 'Nissan Dayz' },
        { value: 'prince_pearl', label: 'Prince Pearl' },
        { value: 'unique_coupe', label: 'Unique Coupe' },
        { value: 'other_car', label: 'Other Car' }
    ];

    // Color options
    const colorOptions = [
        { value: '', label: 'Select Color' },
        { value: 'red', label: 'Red' },
        { value: 'blue', label: 'Blue' },
        { value: 'green', label: 'Green' },
        { value: 'yellow', label: 'Yellow' },
        { value: 'orange', label: 'Orange' },
        { value: 'purple', label: 'Purple' },
        { value: 'pink', label: 'Pink' },
        { value: 'brown', label: 'Brown' },
        { value: 'black', label: 'Black' },
        { value: 'white', label: 'White' },
        { value: 'gray', label: 'Gray' },
        { value: 'silver', label: 'Silver' },
        { value: 'gold', label: 'Gold' },
        { value: 'beige', label: 'Beige' },
        { value: 'cream', label: 'Cream' },
        { value: 'maroon', label: 'Maroon' },
        { value: 'navy', label: 'Navy Blue' },
        { value: 'teal', label: 'Teal' },
        { value: 'turquoise', label: 'Turquoise' },
        { value: 'lime', label: 'Lime' },
        { value: 'olive', label: 'Olive' },
        { value: 'coral', label: 'Coral' },
        { value: 'salmon', label: 'Salmon' },
        { value: 'lavender', label: 'Lavender' },
        { value: 'violet', label: 'Violet' },
        { value: 'magenta', label: 'Magenta' },
        { value: 'cyan', label: 'Cyan' },
        { value: 'indigo', label: 'Indigo' },
        { value: 'amber', label: 'Amber' },
        { value: 'peach', label: 'Peach' },
        { value: 'mint', label: 'Mint' },
        { value: 'sage', label: 'Sage' },
        { value: 'tan', label: 'Tan' },
        { value: 'ivory', label: 'Ivory' },
        { value: 'charcoal', label: 'Charcoal' },
        { value: 'slate', label: 'Slate' },
        { value: 'champagne', label: 'Champagne' },
        { value: 'rose', label: 'Rose' },
        { value: 'crimson', label: 'Crimson' },
        { value: 'burgundy', label: 'Burgundy' },
        { value: 'plum', label: 'Plum' },
        { value: 'mauve', label: 'Mauve' },
        { value: 'fawn', label: 'Fawn' },
        { value: 'mustard', label: 'Mustard' },
        { value: 'rust', label: 'Rust' },
        { value: 'terracotta', label: 'Terracotta' },
        { value: 'copper', label: 'Copper' },
        { value: 'bronze', label: 'Bronze' },
        { value: 'metallic', label: 'Metallic' },
        { value: 'multi', label: 'Multi-Color' },
        { value: 'transparent', label: 'Transparent' },
        { value: 'other', label: 'Other' }
    ];

    // Size options
    const sizeOptions = [
        { value: '', label: 'Select Size' },
        // Standard sizes
        { value: 's', label: 'S' },
        { value: 'm', label: 'M' },
        { value: 'l', label: 'L' },
        { value: 'xl', label: 'XL' },
        { value: 'xxl', label: 'XXL' },
        { value: 'xxxl', label: 'XXXL' },
        { value: '4xl', label: '4XL' },
        { value: '5xl', label: '5XL' },
        { value: '6xl', label: '6XL' },
        { value: '7xl', label: '7XL' },
        { value: '8xl', label: '8XL' },
        // Numeric sizes
        { value: '0', label: '0' },
        { value: '1', label: '1' },
        { value: '2', label: '2' },
        { value: '3', label: '3' },
        { value: '4', label: '4' },
        { value: '5', label: '5' },
        { value: '6', label: '6' },
        { value: '7', label: '7' },
        { value: '8', label: '8' },
        { value: '9', label: '9' },
        { value: '10', label: '10' },
        { value: '11', label: '11' },
        { value: '12', label: '12' },
        { value: '13', label: '13' },
        { value: '14', label: '14' },
        // CM sizes
        { value: '1_cm', label: '1 cm' },
        { value: '2_cm', label: '2 cm' },
        { value: '3_cm', label: '3 cm' },
        { value: '4_cm', label: '4 cm' },
        { value: '5_cm', label: '5 cm' },
        { value: '6_cm', label: '6 cm' },
        { value: '7_cm', label: '7 cm' },
        { value: '8_cm', label: '8 cm' },
        { value: '9_cm', label: '9 cm' },
        { value: '10_cm', label: '10 cm' },
        { value: '11_cm', label: '11 cm' },
        { value: '12_cm', label: '12 cm' },
        { value: '13_cm', label: '13 cm' },
        { value: '14_cm', label: '14 cm' },
        { value: '15_cm', label: '15 cm' },
        { value: '16_cm', label: '16 cm' },
        { value: '17_cm', label: '17 cm' },
        { value: '18_cm', label: '18 cm' },
        { value: '19_cm', label: '19 cm' },
        { value: '20_cm', label: '20 cm' },
        { value: '22_cm', label: '22 cm' },
        { value: '24_cm', label: '24 cm' },
        { value: '25_cm', label: '25 cm' },
        { value: '26_cm', label: '26 cm' },
        { value: '28_cm', label: '28 cm' },
        { value: '30_cm', label: '30 cm' },
        { value: '32_cm', label: '32 cm' },
        { value: '35_cm', label: '35 cm' },
        { value: '40_cm', label: '40 cm' },
        { value: '45_cm', label: '45 cm' },
        { value: '50_cm', label: '50 cm' },
        { value: '55_cm', label: '55 cm' },
        { value: '60_cm', label: '60 cm' },
        { value: '65_cm', label: '65 cm' },
        { value: '70_cm', label: '70 cm' },
        { value: '75_cm', label: '75 cm' },
        { value: '80_cm', label: '80 cm' },
        { value: '85_cm', label: '85 cm' },
        { value: '90_cm', label: '90 cm' },
        { value: '95_cm', label: '95 cm' },
        { value: '100_cm', label: '100 cm' },
        // Feet sizes
        { value: '1_ft', label: '1 ft' },
        { value: '2_ft', label: '2 ft' },
        { value: '3_ft', label: '3 ft' },
        { value: '4_ft', label: '4 ft' },
        { value: '5_ft', label: '5 ft' },
        { value: '6_ft', label: '6 ft' },
        { value: '7_ft', label: '7 ft' },
        { value: '8_ft', label: '8 ft' },
        { value: '9_ft', label: '9 ft' },
        { value: '10_ft', label: '10 ft' },
        { value: '11_ft', label: '11 ft' },
        { value: '12_ft', label: '12 ft' },
        { value: '13_ft', label: '13 ft' },
        { value: '14_ft', label: '14 ft' },
        { value: '15_ft', label: '15 ft' },
        { value: '16_ft', label: '16 ft' },
        { value: '17_ft', label: '17 ft' },
        { value: '18_ft', label: '18 ft' },
        { value: '19_ft', label: '19 ft' },
        { value: '20_ft', label: '20 ft' },
        // Meter sizes
        { value: '0.5_m', label: '0.5 m' },
        { value: '1_m', label: '1 m' },
        { value: '1.5_m', label: '1.5 m' },
        { value: '2_m', label: '2 m' },
        { value: '2.5_m', label: '2.5 m' },
        { value: '3_m', label: '3 m' },
        { value: '4_m', label: '4 m' },
        { value: '5_m', label: '5 m' },
        { value: '6_m', label: '6 m' },
        { value: '7_m', label: '7 m' },
        { value: '8_m', label: '8 m' },
        { value: '9_m', label: '9 m' },
        { value: '10_m', label: '10 m' },
        { value: '12_m', label: '12 m' },
        { value: '15_m', label: '15 m' },
        { value: '20_m', label: '20 m' },
        { value: '25_m', label: '25 m' },
        { value: '30_m', label: '30 m' },
        { value: '40_m', label: '40 m' },
        { value: '50_m', label: '50 m' },
        { value: '60_m', label: '60 m' },
        { value: '70_m', label: '70 m' },
        { value: '80_m', label: '80 m' },
        { value: '90_m', label: '90 m' },
        { value: '100_m', label: '100 m' },
        // GSM sizes
        { value: '60_gsm', label: '60 GSM' },
        { value: '70_gsm', label: '70 GSM' },
        { value: '80_gsm', label: '80 GSM' },
        { value: '90_gsm', label: '90 GSM' },
        { value: '100_gsm', label: '100 GSM' },
        { value: '120_gsm', label: '120 GSM' },
        { value: '140_gsm', label: '140 GSM' },
        { value: '160_gsm', label: '160 GSM' },
        { value: '180_gsm', label: '180 GSM' },
        { value: '200_gsm', label: '200 GSM' },
        { value: '250_gsm', label: '250 GSM' },
        { value: '300_gsm', label: '300 GSM' },
        { value: '350_gsm', label: '350 GSM' },
        // Other sizes
        { value: 'one_size', label: 'One Size' },
        { value: 'free_size', label: 'Free Size' },
        { value: 'adjustable', label: 'Adjustable' },
        { value: 'custom', label: 'Custom' },
        { value: 'other', label: 'Other' }
    ];

    // Initial form data
    const initialFormData = {
        date: new Date().toISOString().split('T')[0],
        batch_no: '',
        barcode: '',
        product_name: '',
        product_code: '',
        category: '',
        company: '',
        color: '',
        size: '',
        packing_type: '',
        sub_packing_type: '',
        items_per_pack: '',
        unit_of_measure: '',
        cost_price_per_pack: '',
        sell_price_per_unit: '',
        total_quantity: '',
        quantity_alert: '',
        expiry_date: '',
        cost_per_unit: '',
        sell_per_pack: '',
        bquantity: '',
        purchase_type: 'packing',
        themeColor: localStorage.getItem('ourzest_theme') || '#6366f1'
    };

    const [formData, setFormData] = useState(initialFormData);
    const [errors, setErrors] = useState({});
    const [loading, setLoading] = useState(false);
    const [isEditMode, setIsEditMode] = useState(false);
    const [translations, setTranslations] = useState({});
    const [toast, setToast] = useState({ show: false, type: '', message: '' });
    const [showShopSelector, setShowShopSelector] = useState(false);
    const [availableShops, setAvailableShops] = useState([]);
    const [loadingShops, setLoadingShops] = useState(false);
    const [availableSubPackings, setAvailableSubPackings] = useState([]);
    const [hasDraft, setHasDraft] = useState(false);
    const [darkMode, setDarkMode] = useState(() => {
        return localStorage.getItem('ourzest_darkMode') === 'true';
    });
    const [currentThemeColor, setCurrentThemeColor] = useState(() => {
        return localStorage.getItem('ourzest_theme') || '#6366f1';
    });
    const [showDraftsList, setShowDraftsList] = useState(false);
    const [savedDrafts, setSavedDrafts] = useState([]);
    
    // Manual dropdown states
    const [showCategoryDropdown, setShowCategoryDropdown] = useState(false);
    const [categorySearchTerm, setCategorySearchTerm] = useState('');
    const [showPackingTypeDropdown, setShowPackingTypeDropdown] = useState(false);
    const [packingTypeSearchTerm, setPackingTypeSearchTerm] = useState('');
    const [showSubPackingDropdown, setShowSubPackingDropdown] = useState(false);
    const [subPackingSearchTerm, setSubPackingSearchTerm] = useState('');
    const [showUnitDropdown, setShowUnitDropdown] = useState(false);
    const [unitSearchTerm, setUnitSearchTerm] = useState('');
    const [showColorDropdown, setShowColorDropdown] = useState(false);
    const [colorSearchTerm, setColorSearchTerm] = useState('');
    const [showSizeDropdown, setShowSizeDropdown] = useState(false);
    const [sizeSearchTerm, setSizeSearchTerm] = useState('');
    
    // Refs for dropdowns
    const categoryDropdownRef = useRef(null);
    const packingTypeDropdownRef = useRef(null);
    const subPackingDropdownRef = useRef(null);
    const unitDropdownRef = useRef(null);
    const colorDropdownRef = useRef(null);
    const sizeDropdownRef = useRef(null);
    
    // State for calculated display values
    const [calculatedCostPerUnit, setCalculatedCostPerUnit] = useState('');
    const [calculatedSellPerPack, setCalculatedSellPerPack] = useState('');
    const [calculatedBQuantity, setCalculatedBQuantity] = useState('');

    // Dynamic labels state
    const [dynamicLabels, setDynamicLabels] = useState({
        packingName: 'Pack',
        packingNamePlural: 'Packs',
        itemsPerPackLabel: 'Items Per Pack',
        costPerPackLabel: 'Cost Per Pack',
        sellingPerPackLabel: 'Selling Price Per Pack'
    });

    // Refs for preventing duplicate submissions
    const isSubmittingRef = useRef(false);
    const toastTimerRef = useRef(null);
    const lastSubmitTimeRef = useRef(0);
    const lastProductDataRef = useRef('');
    const isInitialLoadRef = useRef(true);
    const isClearingRef = useRef(false);
    const draftsDropdownRef = useRef(null);
    const lastDraftContentRef = useRef('');
    const isAutoSavingRef = useRef(false);

    // UPDATED: Helper function to get unit numeric value
    const getUnitNumericValue = (unitOfMeasure) => {
        const unitValues = {
            // Liter options
            '1_liter': 1,
            '2_liter': 2,
            '3_liter': 3,
            '5_liter': 5,
            // NEW: ml units
            '200_ml': 0.2,
            '250_ml': 0.25,
            '300_ml': 0.3,
            '350_ml': 0.35,
            '400_ml': 0.4,
            '450_ml': 0.45,
            '500_ml': 0.5,
            // NEW: liter units
            '0.5_liter': 0.5,
            '0.7_liter': 0.7,
            '1_liter_alt': 1,
            '2_liter_alt': 2,
            '3_liter_alt': 3,
            '4_liter': 4,
            '5_liter_alt': 5,
            '6_liter': 6,
            '7_liter': 7,
            '10_liter': 10,
            '20_liter': 20,
            '60_liter': 60,
            '208_liter': 208,
            // Other units
            'milliliter': 0.001,
            'kilogram': 1,
            'gram': 0.001,
            'piece': 1,
            'dozen': 12,
            'box': 1,
            'packet': 1,
            'can': 1,
            'bottle': 1
        };
        return unitValues[unitOfMeasure] || 1;
    };

    // UPDATED: Helper function to get unit display label
    const getUnitDisplayLabel = (unitOfMeasure) => {
        const labels = {
            '1_liter': 'Liter',
            '2_liter': 'Liter',
            '3_liter': 'Liter',
            '5_liter': 'Liter',
            '200_ml': 'Milliliter',
            '250_ml': 'Milliliter',
            '300_ml': 'Milliliter',
            '350_ml': 'Milliliter',
            '400_ml': 'Milliliter',
            '450_ml': 'Milliliter',
            '500_ml': 'Milliliter',
            '0.5_liter': 'Liter',
            '0.7_liter': 'Liter',
            '1_liter_alt': 'Liter',
            '2_liter_alt': 'Liter',
            '3_liter_alt': 'Liter',
            '4_liter': 'Liter',
            '5_liter_alt': 'Liter',
            '6_liter': 'Liter',
            '7_liter': 'Liter',
            '10_liter': 'Liter',
            '20_liter': 'Liter',
            '60_liter': 'Liter',
            '208_liter': 'Liter',
            'milliliter': 'Milliliter',
            'kilogram': 'Kilogram',
            'gram': 'Gram',
            'piece': 'Piece',
            'dozen': 'Dozen',
            'box': 'Box',
            'packet': 'Packet',
            'can': 'Can',
            'bottle': 'Bottle'
        };
        return labels[unitOfMeasure] || 'Unit';
    };

    // UPDATED: Helper function to get plural unit label
    const getPluralUnitLabel = (label) => {
        const plurals = {
            'Liter': 'Liters',
            'Milliliter': 'Milliliters',
            'Kilogram': 'Kilograms',
            'Gram': 'Grams',
            'Piece': 'Pieces',
            'Dozen': 'Dozens',
            'Box': 'Boxes',
            'Packet': 'Packets',
            'Can': 'Cans',
            'Bottle': 'Bottles',
            'Unit': 'Units'
        };
        return plurals[label] || label + 's';
    };

    // AUTO-GENERATE BATCH NUMBER FROM PRODUCT NAME - UPDATED to 6 characters
    useEffect(() => {
        // Only auto-generate if:
        // 1. Not in edit mode
        // 2. Product name exists and is not empty
        // 3. Not loading
        // 4. Not clearing form
        if (!isEditMode && formData.product_name && formData.product_name.trim() !== '' && !loading && !isClearingRef.current) {
            const newBatchNo = generateBatchNoFromProductName(formData.product_name);
            
            // Only update if the batch number has changed
            if (formData.batch_no !== newBatchNo) {
                setFormData(prev => ({ ...prev, batch_no: newBatchNo }));
                
                // Show toast notification
                const message = (translations.batchAutoGenerated || 'Batch number auto-generated: ') + newBatchNo;
                showToast('info', message);
            }
        }
    }, [formData.product_name, isEditMode, loading, translations]);

    // Clear batch number if product name is cleared (only in add mode)
    useEffect(() => {
        if (!isEditMode && (!formData.product_name || formData.product_name.trim() === '') && formData.batch_no !== '' && !loading) {
            setFormData(prev => ({ ...prev, batch_no: '' }));
        }
    }, [formData.product_name, isEditMode, loading]);

    // Update dynamic labels when packing type changes
    useEffect(() => {
        const packingName = getPackingTypeDisplayName(formData.packing_type);
        const packingNamePlural = getPluralPackingName(formData.packing_type);
        
        setDynamicLabels({
            packingName: packingName,
            packingNamePlural: packingNamePlural,
            itemsPerPackLabel: `Items Per ${packingName}`,
            costPerPackLabel: `Cost Per ${packingName}`,
            sellingPerPackLabel: `Selling Price Per ${packingName}`
        });
    }, [formData.packing_type]);

    // Filtered options for dropdowns
    const filteredCategories = categorySearchTerm.trim() === '' 
        ? categoryOptions 
        : categoryOptions.filter(cat => 
            cat.label.toLowerCase().includes(categorySearchTerm.toLowerCase())
          );

    const filteredPackingTypes = packingTypeSearchTerm.trim() === ''
        ? packingTypes.filter(pt => pt.value !== '')
        : packingTypes.filter(pt => 
            pt.value !== '' && (translations[pt.label] || pt.label).toLowerCase().includes(packingTypeSearchTerm.toLowerCase())
          );

    const filteredSubPackings = subPackingSearchTerm.trim() === ''
        ? availableSubPackings
        : availableSubPackings.filter(sub => 
            sub.label.toLowerCase().includes(subPackingSearchTerm.toLowerCase())
          );

    const filteredUnits = unitSearchTerm.trim() === ''
        ? unitsOfMeasure.filter(u => u.value !== '')
        : unitsOfMeasure.filter(u => 
            u.value !== '' && u.label.toLowerCase().includes(unitSearchTerm.toLowerCase())
          );

    const filteredColors = colorSearchTerm.trim() === '' 
        ? colorOptions.filter(c => c.value !== '')
        : colorOptions.filter(c => 
            c.value !== '' && c.label.toLowerCase().includes(colorSearchTerm.toLowerCase())
          );

    const filteredSizes = sizeSearchTerm.trim() === ''
        ? sizeOptions.filter(s => s.value !== '')
        : sizeOptions.filter(s => 
            s.value !== '' && s.label.toLowerCase().includes(sizeSearchTerm.toLowerCase())
          );

    // Click outside handlers for dropdowns
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (categoryDropdownRef.current && !categoryDropdownRef.current.contains(event.target)) {
                setShowCategoryDropdown(false);
            }
            if (packingTypeDropdownRef.current && !packingTypeDropdownRef.current.contains(event.target)) {
                setShowPackingTypeDropdown(false);
            }
            if (subPackingDropdownRef.current && !subPackingDropdownRef.current.contains(event.target)) {
                setShowSubPackingDropdown(false);
            }
            if (unitDropdownRef.current && !unitDropdownRef.current.contains(event.target)) {
                setShowUnitDropdown(false);
            }
            if (colorDropdownRef.current && !colorDropdownRef.current.contains(event.target)) {
                setShowColorDropdown(false);
            }
            if (sizeDropdownRef.current && !sizeDropdownRef.current.contains(event.target)) {
                setShowSizeDropdown(false);
            }
        };
        document.addEventListener('mousedown', handleClickOutside);
        return () => document.removeEventListener('mousedown', handleClickOutside);
    }, []);

    // Function to calculate BQuantity string
    const calculateBQuantityString = (itemsPerPack, unitOfMeasure, totalQuantity) => {
        if (!itemsPerPack || itemsPerPack <= 0 || !totalQuantity || totalQuantity <= 0 || !unitOfMeasure) {
            return '';
        }
        
        const unitValue = getUnitNumericValue(unitOfMeasure);
        const totalItems = itemsPerPack * totalQuantity;
        const bulkValue = totalItems * unitValue;
        const unitLabel = getUnitDisplayLabel(unitOfMeasure);
        
        let formattedValue;
        if (Math.floor(bulkValue) === bulkValue) {
            formattedValue = bulkValue.toFixed(0);
        } else {
            formattedValue = bulkValue.toFixed(2);
        }
        
        const finalLabel = bulkValue !== 1 ? getPluralUnitLabel(unitLabel) : unitLabel;
        
        return `${formattedValue} ${finalLabel}`;
    };

    // Function to calculate cost per unit numeric value (from cost per pack)
    const calculateCostPerUnitNumeric = (costPerPack, itemsPerPack, unitOfMeasure) => {
        if (!costPerPack || costPerPack <= 0 || !itemsPerPack || itemsPerPack <= 0) {
            return 0;
        }
        const perUnit = costPerPack / itemsPerPack;
        const unitValue = getUnitNumericValue(unitOfMeasure);
        const costPerBaseUnit = perUnit / unitValue;
        return costPerBaseUnit;
    };

    // Function to calculate sell per pack from sell price per unit
    const calculateSellPerPackFromUnit = (sellPricePerUnit, itemsPerPack, unitOfMeasure) => {
        if (!sellPricePerUnit || sellPricePerUnit <= 0 || !itemsPerPack || itemsPerPack <= 0 || !unitOfMeasure) {
            return 0;
        }
        const unitValue = getUnitNumericValue(unitOfMeasure);
        const perUnitPrice = sellPricePerUnit * unitValue;
        const sellPerPack = perUnitPrice * itemsPerPack;
        return sellPerPack;
    };

    // Format number with appropriate decimals
    const formatPrice = (value) => {
        if (value === 0) return '';
        if (value < 0.01) return value.toFixed(4);
        if (value < 1) return value.toFixed(3);
        return value.toFixed(2);
    };

    // Calculate and update the form fields whenever dependencies change
    useEffect(() => {
        let newCostPerUnit = '';
        let newSellPerPack = '';
        let newBQuantity = '';
        
        // Calculate cost per unit from cost per pack
        if (formData.cost_price_per_pack && formData.items_per_pack && formData.unit_of_measure) {
            const cpuNumeric = calculateCostPerUnitNumeric(
                parseFloat(formData.cost_price_per_pack),
                parseFloat(formData.items_per_pack),
                formData.unit_of_measure
            );
            newCostPerUnit = formatPrice(cpuNumeric);
            setCalculatedCostPerUnit(newCostPerUnit);
        } else {
            setCalculatedCostPerUnit('');
        }
        
        // Calculate sell per pack from sell price per unit
        if (formData.sell_price_per_unit && formData.items_per_pack && formData.unit_of_measure) {
            const spPackNumeric = calculateSellPerPackFromUnit(
                parseFloat(formData.sell_price_per_unit),
                parseFloat(formData.items_per_pack),
                formData.unit_of_measure
            );
            newSellPerPack = formatPrice(spPackNumeric);
            setCalculatedSellPerPack(newSellPerPack);
        } else {
            setCalculatedSellPerPack('');
        }
        
        // Calculate BQuantity
        if (formData.items_per_pack && formData.unit_of_measure && formData.total_quantity) {
            newBQuantity = calculateBQuantityString(
                parseFloat(formData.items_per_pack),
                formData.unit_of_measure,
                parseFloat(formData.total_quantity)
            );
            setCalculatedBQuantity(newBQuantity);
        } else {
            setCalculatedBQuantity('');
        }
        
        // Update formData with calculated values
        setFormData(prev => ({
            ...prev,
            cost_per_unit: newCostPerUnit,
            sell_per_pack: newSellPerPack,
            bquantity: newBQuantity
        }));
        
    }, [formData.cost_price_per_pack, formData.sell_price_per_unit, formData.items_per_pack, formData.unit_of_measure, formData.total_quantity]);

    // Draft Management Functions
    const getDraftStorageKey = () => {
        const userId = user?.user_id || user?.username || 'anonymous';
        const shopId = currentShop?.shop_id || 'no_shop';
        return `product_draft_${userId}_${shopId}`;
    };

    // Get current form data as string for comparison
    const getCurrentFormContent = () => {
        return JSON.stringify({
            product_name: formData.product_name || '',
            batch_no: formData.batch_no || '',
            product_code: formData.product_code || '',
            company: formData.company || '',
            color: formData.color || '',
            size: formData.size || '',
            packing_type: formData.packing_type || '',
            sub_packing_type: formData.sub_packing_type || '',
            items_per_pack: formData.items_per_pack || '',
            unit_of_measure: formData.unit_of_measure || '',
            cost_price_per_pack: formData.cost_price_per_pack || '',
            sell_price_per_unit: formData.sell_price_per_unit || '',
            total_quantity: formData.total_quantity || '',
            quantity_alert: formData.quantity_alert || ''
        });
    };

    const saveDraft = () => {
        // Don't save if in edit mode or clearing
        if (isEditMode || isClearingRef.current) {
            if (isEditMode) showToast('warning', 'Cannot save draft in edit mode');
            return false;
        }
        
        // Check if there's actual data to save
        const hasData = formData.product_name?.trim() ||
            formData.batch_no?.trim() ||
            formData.product_code?.trim() ||
            formData.company?.trim() ||
            formData.color?.trim() ||
            formData.size?.trim() ||
            formData.packing_type ||
            formData.cost_price_per_pack ||
            formData.sell_price_per_unit;

        if (!hasData) {
            showToast('warning', 'Cannot save empty draft. Please enter at least one field.');
            return false;
        }

        const currentContent = getCurrentFormContent();
        
        // Don't save if content hasn't changed
        if (currentContent === lastDraftContentRef.current) {
            showToast('info', 'No changes to save');
            return false;
        }
        
        lastDraftContentRef.current = currentContent;
        
        const draftId = Date.now();
        const draft = {
            id: draftId,
            ...formData,
            savedAt: new Date().toISOString(),
            shop_id: currentShop?.shop_id
        };
        
        // Get existing drafts
        const existingDrafts = JSON.parse(localStorage.getItem('product_drafts') || '[]');
        
        // Remove any existing draft for the same product (based on product_name + batch_no)
        const filteredDrafts = existingDrafts.filter(d => 
            !(d.product_name === formData.product_name && 
              d.batch_no === formData.batch_no &&
              d.shop_id === currentShop?.shop_id)
        );
        
        // Add new draft at the beginning
        filteredDrafts.unshift(draft);
        
        // Keep only last 20 drafts
        const limitedDrafts = filteredDrafts.slice(0, 20);
        localStorage.setItem('product_drafts', JSON.stringify(limitedDrafts));
        
        loadDrafts();
        showToast('success', 'Draft saved successfully!');
        return true;
    };

    const loadDrafts = () => {
        const drafts = JSON.parse(localStorage.getItem('product_drafts') || '[]');
        const filteredDrafts = currentShop ? drafts.filter(d => d.shop_id === currentShop?.shop_id) : drafts;
        setSavedDrafts(filteredDrafts);
        // Update hasDraft state
        setHasDraft(filteredDrafts.length > 0);
    };

    const loadDraft = (draft) => {
        setFormData({
            date: draft.date || new Date().toISOString().split('T')[0],
            batch_no: draft.batch_no || '',
            barcode: draft.barcode || '',
            product_name: draft.product_name || '',
            product_code: draft.product_code || '',
            category: draft.category || '',
            company: draft.company || '',
            color: draft.color || '',
            size: draft.size || '',
            packing_type: draft.packing_type || '',
            sub_packing_type: draft.sub_packing_type || '',
            items_per_pack: draft.items_per_pack || '',
            unit_of_measure: draft.unit_of_measure || '',
            cost_price_per_pack: draft.cost_price_per_pack || '',
            sell_price_per_unit: draft.sell_price_per_unit || '',
            total_quantity: draft.total_quantity || '',
            quantity_alert: draft.quantity_alert || '',
            expiry_date: draft.expiry_date || '',
            cost_per_unit: draft.cost_per_unit || '',
            sell_per_pack: draft.sell_per_pack || '',
            bquantity: draft.bquantity || '',
            purchase_type: draft.purchase_type || 'packing',
            themeColor: formData.themeColor
        });
        
        // Update search terms
        const selectedCategory = categoryOptions.find(c => c.value === draft.category);
        setCategorySearchTerm(selectedCategory ? selectedCategory.label : '');
        const selectedPackingType = packingTypes.find(p => p.value === draft.packing_type);
        setPackingTypeSearchTerm(selectedPackingType ? (translations[selectedPackingType.label] || selectedPackingType.label) : '');
        const selectedSubPacking = availableSubPackings.find(s => s.value === draft.sub_packing_type);
        setSubPackingSearchTerm(selectedSubPacking ? selectedSubPacking.label : '');
        const selectedUnit = unitsOfMeasure.find(u => u.value === draft.unit_of_measure);
        setUnitSearchTerm(selectedUnit ? selectedUnit.label : '');
        const selectedColor = colorOptions.find(c => c.value === draft.color);
        setColorSearchTerm(selectedColor ? selectedColor.label : '');
        const selectedSize = sizeOptions.find(s => s.value === draft.size);
        setSizeSearchTerm(selectedSize ? selectedSize.label : '');
        
        // Update last saved content to prevent auto-save after load
        lastDraftContentRef.current = getCurrentFormContent();
        
        setShowDraftsList(false);
        showToast('success', translations.draftLoaded || 'Draft loaded successfully!');
        
        // Focus on product name after loading draft
        setTimeout(() => {
            if (productNameRef.current) {
                productNameRef.current.focus();
            }
        }, 100);
    };

    const deleteDraft = (draftId) => {
        const drafts = JSON.parse(localStorage.getItem('product_drafts') || '[]');
        const filteredDrafts = drafts.filter(d => d.id !== draftId);
        localStorage.setItem('product_drafts', JSON.stringify(filteredDrafts));
        loadDrafts();
        showToast('success', 'Draft deleted successfully!');
        
        // Clear last draft content if no drafts left
        if (filteredDrafts.length === 0) {
            lastDraftContentRef.current = '';
        }
    };

    useEffect(() => {
        loadDrafts();
    }, [currentShop]);

    // Add this useEffect to position the drafts dropdown
    useEffect(() => {
        if (showDraftsList && draftsDropdownRef.current) {
            const button = draftsDropdownRef.current.querySelector('.drafts-btn');
            const dropdown = draftsDropdownRef.current.querySelector('.ozui-drafts-dropdown');
            
            if (button && dropdown) {
                const rect = button.getBoundingClientRect();
                dropdown.style.position = 'fixed';
                dropdown.style.top = `${rect.bottom + 8}px`;
                dropdown.style.right = `${window.innerWidth - rect.right}px`;
            }
        }
    }, [showDraftsList]);

    // Click outside for drafts dropdown
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (draftsDropdownRef.current && !draftsDropdownRef.current.contains(event.target)) {
                setShowDraftsList(false);
            }
        };
        document.addEventListener('mousedown', handleClickOutside);
        return () => document.removeEventListener('mousedown', handleClickOutside);
    }, []);

    const showToast = (type, message) => {
        if (toastTimerRef.current) clearTimeout(toastTimerRef.current);
        setToast({ show: true, type, message });
        toastTimerRef.current = setTimeout(() => {
            setToast({ show: false, type: '', message: '' });
        }, 3000);
    };

    // Auto-save draft when form data changes (debounced)
    useEffect(() => {
        if (isEditMode || isClearingRef.current || isSubmittingRef.current) return;
        
        // Don't auto-save on initial load
        if (isInitialLoadRef.current) return;
        
        // Debounce auto-save
        const timer = setTimeout(() => {
            if (!isAutoSavingRef.current) {
                isAutoSavingRef.current = true;
                saveDraft();
                isAutoSavingRef.current = false;
            }
        }, 3000); // Wait 3 seconds after last change before auto-saving
        
        return () => clearTimeout(timer);
    }, [
        formData.product_name,
        formData.batch_no,
        formData.product_code,
        formData.company,
        formData.color,
        formData.size,
        formData.packing_type,
        formData.sub_packing_type,
        formData.items_per_pack,
        formData.unit_of_measure,
        formData.cost_price_per_pack,
        formData.sell_price_per_unit,
        formData.total_quantity,
        formData.quantity_alert,
        isEditMode
    ]);

    // Check for existing draft on mount
    useEffect(() => {
        if (!isEditMode && !productId && currentShop && isInitialLoadRef.current) {
            isInitialLoadRef.current = false;
            const draftKey = getDraftStorageKey();
            const savedDraft = localStorage.getItem(draftKey);
            if (savedDraft) {
                setHasDraft(true);
                showToast('info', translations.draftExists || 'A saved draft exists');
            }
            // Initialize last draft content
            lastDraftContentRef.current = getCurrentFormContent();
        }
    }, [currentShop, isEditMode, productId]);

    // Update last draft content when form is cleared
    useEffect(() => {
        if (isClearingRef.current) {
            lastDraftContentRef.current = '';
        }
    }, [formData.product_name]);

    useEffect(() => {
        return () => {
            if (toastTimerRef.current) clearTimeout(toastTimerRef.current);
            isSubmittingRef.current = false;
        };
    }, []);

    useEffect(() => {
        if (user?.language && user.language !== currentLanguage) {
            setCurrentLanguage(user.language);
        }
    }, [user?.language]);

    useEffect(() => {
        const loadTranslations = async () => {
            const trans = await productsTranslator.getTranslations(currentLanguage);
            setTranslations(trans);
        };
        loadTranslations();
    }, [currentLanguage]);

    useEffect(() => {
        if (productId) {
            setIsEditMode(true);
            loadProductData(productId);
        }
    }, [productId]);

    useEffect(() => {
        if (formData.batch_no && !isEditMode && currentShop) {
            generateBarcode();
        }
    }, [formData.batch_no, isEditMode, currentShop]);

    useEffect(() => {
        const loadAvailableShops = async () => {
            if (!user) return;
            setLoadingShops(true);
            try {
                const shopsData = await getShopsForSwitch();
                setAvailableShops(shopsData.shops || []);
            } catch (error) {
                console.error('Error loading shops:', error);
            } finally {
                setLoadingShops(false);
            }
        };
        loadAvailableShops();
    }, [user, getShopsForSwitch]);

    // Update sub packing options when packing type changes
    useEffect(() => {
        if (formData.packing_type && subPackingTypes[formData.packing_type]) {
            setAvailableSubPackings(subPackingTypes[formData.packing_type]);
            if (formData.sub_packing_type) {
                setFormData(prev => ({ ...prev, sub_packing_type: '', items_per_pack: '', unit_of_measure: '' }));
                setSubPackingSearchTerm('');
            }
        } else {
            setAvailableSubPackings([]);
        }
    }, [formData.packing_type]);

    // Update items per pack and unit of measure when sub packing type changes
    const handleSubPackingChange = (subPackingValue, subPackingLabel) => {
        const selectedSubPacking = availableSubPackings.find(sp => sp.value === subPackingValue);
        if (selectedSubPacking) {
            setFormData(prev => ({
                ...prev,
                sub_packing_type: subPackingValue,
                items_per_pack: selectedSubPacking.defaultQty.toString(),
                unit_of_measure: selectedSubPacking.defaultUnit
            }));
            setSubPackingSearchTerm(subPackingLabel);
            // Update unit search term
            const selectedUnit = unitsOfMeasure.find(u => u.value === selectedSubPacking.defaultUnit);
            if (selectedUnit) {
                setUnitSearchTerm(selectedUnit.label);
            }
        } else {
            setFormData(prev => ({
                ...prev,
                sub_packing_type: subPackingValue,
                items_per_pack: '',
                unit_of_measure: ''
            }));
            setSubPackingSearchTerm(subPackingLabel);
        }
        setShowSubPackingDropdown(false);
    };

    // Select handlers for dropdowns
    const selectCategory = (category) => {
        setFormData(prev => ({ ...prev, category: category.value }));
        setCategorySearchTerm(category.label);
        setShowCategoryDropdown(false);
    };

    const selectPackingType = (packingType) => {
        setFormData(prev => ({ ...prev, packing_type: packingType.value, sub_packing_type: '', items_per_pack: '', unit_of_measure: '' }));
        setPackingTypeSearchTerm(translations[packingType.label] || packingType.label);
        setSubPackingSearchTerm('');
        setUnitSearchTerm('');
        setShowPackingTypeDropdown(false);
    };

    const selectUnit = (unit) => {
        setFormData(prev => ({ ...prev, unit_of_measure: unit.value }));
        setUnitSearchTerm(unit.label);
        setShowUnitDropdown(false);
    };

    const selectColor = (color) => {
        setFormData(prev => ({ ...prev, color: color.value }));
        setColorSearchTerm(color.label);
        setShowColorDropdown(false);
    };

    const selectSize = (size) => {
        setFormData(prev => ({ ...prev, size: size.value }));
        setSizeSearchTerm(size.label);
        setShowSizeDropdown(false);
    };

    const validateForm = () => {
        const newErrors = {};

        if (!formData.product_name?.trim()) {
            newErrors.product_name = translations.nameRequired || 'Product name is required';
        } else if (formData.product_name.trim().length < 2) {
            newErrors.product_name = translations.nameTooShort || 'Name must be at least 2 characters';
        }

        if (!formData.packing_type) {
            newErrors.packing_type = 'Packing type is required';
        }

        if (!formData.sub_packing_type) {
            newErrors.sub_packing_type = 'Sub packing type is required';
        }

        if (!formData.items_per_pack || parseFloat(formData.items_per_pack) <= 0) {
            newErrors.items_per_pack = 'Items per pack is required';
        }

        if (!formData.unit_of_measure) {
            newErrors.unit_of_measure = 'Unit of measure is required';
        }

        if (!formData.cost_price_per_pack || parseFloat(formData.cost_price_per_pack) <= 0) {
            newErrors.cost_price_per_pack = translations.costPriceRequired || 'Cost price is required';
        }

        if (!formData.sell_price_per_unit || parseFloat(formData.sell_price_per_unit) <= 0) {
            newErrors.sell_price_per_unit = translations.sellingPriceRequired || 'Selling price per unit is required';
        }

        if (!formData.total_quantity || parseFloat(formData.total_quantity) < 0) {
            newErrors.total_quantity = translations.quantityRequired || 'Quantity is required';
        }

        if (!formData.quantity_alert || parseFloat(formData.quantity_alert) < 0) {
            newErrors.quantity_alert = translations.alertRequired || 'Low stock alert quantity is required';
        }

        if (formData.expiry_date) {
            const expiry = new Date(formData.expiry_date);
            const today = new Date();
            today.setHours(0, 0, 0, 0);
            if (expiry < today) {
                newErrors.expiry_date = translations.expiryPast || 'Expiry date cannot be in the past';
            }
        }

        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        e.stopPropagation();

        if (!currentShop) {
            showToast('error', translations.selectShop || 'Please select a shop first');
            setShowShopSelector(true);
            return;
        }

        // Ensure batch number is generated if product name exists but batch number is empty
        if (!isEditMode && formData.product_name && formData.product_name.trim() !== '' && (!formData.batch_no || formData.batch_no.trim() === '')) {
            const newBatchNo = generateBatchNoFromProductName(formData.product_name);
            setFormData(prev => ({ ...prev, batch_no: newBatchNo }));
            // Small delay to allow state to update
            await new Promise(resolve => setTimeout(resolve, 50));
        }

        if (!validateForm()) return;

        if (isSubmittingRef.current) {
            showToast('warning', 'Please wait, submission in progress...');
            return;
        }

        const now = Date.now();
        if (now - lastSubmitTimeRef.current < 3000) {
            showToast('warning', 'Please wait before submitting again');
            return;
        }

        const currentProductData = JSON.stringify({
            product_name: formData.product_name,
            batch_no: formData.batch_no,
            product_code: formData.product_code,
            shop_id: currentShop.shop_id
        });

        if (!isEditMode && currentProductData === lastProductDataRef.current) {
            showToast('warning', 'This product appears to be a duplicate. Please check.');
            return;
        }

        if (!isEditMode && isDuplicateRequest({
            action: 'add',
            product_name: formData.product_name,
            batch_no: formData.batch_no,
            product_code: formData.product_code,
            shop_id: currentShop.shop_id
        })) {
            showToast('warning', 'Please wait, a similar product is being added...');
            return;
        }

        lastProductDataRef.current = currentProductData;
        lastSubmitTimeRef.current = now;

        isSubmittingRef.current = true;
        setLoading(true);

        const submitButton = document.querySelector('button[type="submit"]');
        if (submitButton) submitButton.disabled = true;

        try {
            const currentUsername = user?.username || 'Unknown';
            const itemsPerPack = parseFloat(formData.items_per_pack) || 1;
            
            const productData = {
                action: isEditMode ? 'edit' : 'add',
                product_name: formData.product_name,
                product_code: formData.product_code,
                batch_no: formData.batch_no || '',
                category: formData.category || '',
                company: formData.company || '',
                color: formData.color || '',
                size: formData.size || '',
                date: formData.date,
                expiry_date: formData.expiry_date || null,
                quantity_alert: formData.quantity_alert,
                total_quantity: formData.total_quantity,
                packing_type: formData.packing_type,
                sub_packing_type: formData.sub_packing_type,
                items_per_pack: itemsPerPack,
                unit_of_measure: formData.unit_of_measure,
                cost_price_per_pack: formData.cost_price_per_pack,
                sell_price_per_unit: formData.sell_price_per_unit,
                purchase_type: 'packing',
                username: currentUsername,
                shop_id: currentShop.shop_id,
                _timestamp: Date.now()
            };

            if (isEditMode && productId) {
                productData.id = productId;
            }

            const controller = new AbortController();
            const timeoutId = setTimeout(() => controller.abort(), 30000);

            const response = await fetch('https://ourzestapp.online/oz_backend/mechanics_module/mechanics_products.php', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(productData),
                signal: controller.signal
            });

            clearTimeout(timeoutId);

            if (!response.ok) {
                const errorText = await response.text();
                console.error('Server error response:', errorText);
                throw new Error(`Server responded with status ${response.status}: ${errorText.substring(0, 200)}`);
            }

            const responseText = await response.text();
            
            if (!responseText || responseText.trim() === '') {
                throw new Error('Empty response from server');
            }
            
            let data;
            try {
                data = JSON.parse(responseText);
            } catch (jsonError) {
                console.error('JSON Parse Error. Raw response:', responseText.substring(0, 500));
                throw new Error('Invalid JSON response from server. Please check the server logs.');
            }

            if (data.status === 'duplicate' || data.duplicate_prevention) {
                showToast('warning', data.message || 'Duplicate submission prevented. Please wait.');
                lastProductDataRef.current = '';
                return;
            }

            if (data.status === 'success') {
                showToast('success', isEditMode
                    ? (translations.productUpdated || 'Product updated successfully!')
                    : (translations.productSaved || 'Product saved successfully!'));

                // Clear draft after successful save
                const draftKey = getDraftStorageKey();
                localStorage.removeItem(draftKey);
                setHasDraft(false);
                lastDraftContentRef.current = '';

                if (!isEditMode) {
                    setFormData({
                        date: new Date().toISOString().split('T')[0],
                        batch_no: '',
                        barcode: '',
                        product_name: '',
                        product_code: '',
                        category: '',
                        company: '',
                        color: '',
                        size: '',
                        packing_type: '',
                        sub_packing_type: '',
                        items_per_pack: '',
                        unit_of_measure: '',
                        cost_price_per_pack: '',
                        sell_price_per_unit: '',
                        total_quantity: '',
                        quantity_alert: '',
                        expiry_date: '',
                        cost_per_unit: '',
                        sell_per_pack: '',
                        bquantity: '',
                        purchase_type: 'packing',
                        themeColor: formData.themeColor
                    });
                    setCategorySearchTerm('');
                    setPackingTypeSearchTerm('');
                    setSubPackingSearchTerm('');
                    setUnitSearchTerm('');
                    setColorSearchTerm('');
                    setSizeSearchTerm('');
                    setErrors({});
                    lastProductDataRef.current = '';
                    setCalculatedCostPerUnit('');
                    setCalculatedSellPerPack('');
                    setCalculatedBQuantity('');
                    
                    // Refocus on product name after clearing
                    setTimeout(() => {
                        if (productNameRef.current) {
                            productNameRef.current.focus();
                        }
                    }, 100);
                }

                if (onSuccess) onSuccess(data.productid || productId);
            } else {
                showToast('error', data.message || (isEditMode
                    ? translations.failedUpdate
                    : translations.failedAdd) || 'Operation failed');
                lastProductDataRef.current = '';
            }
        } catch (error) {
            if (error.name === 'AbortError') {
                showToast('error', 'Request timeout. Please try again.');
            } else {
                console.error('Submit error:', error);
                showToast('error', error.message || translations.networkError || 'Network error');
            }
            lastProductDataRef.current = '';
        } finally {
            setTimeout(() => {
                isSubmittingRef.current = false;
                setLoading(false);
                if (submitButton) submitButton.disabled = false;
            }, 3000);
        }
    };

    const handleChange = (e) => {
        const { name, value } = e.target;

        if (name === 'items_per_pack') {
            setFormData(prev => ({ ...prev, [name]: value }));
        } else if (name === 'total_quantity') {
            setFormData(prev => ({ ...prev, [name]: value }));
        } else if (name === 'sell_price_per_unit') {
            setFormData(prev => ({ ...prev, [name]: value }));
        } else if (name === 'cost_per_unit' || name === 'sell_per_pack' || name === 'bquantity') {
            return;
        } else if (name === 'product_name') {
            // When product name changes, the batch number will be auto-generated by the useEffect
            setFormData(prev => ({ ...prev, [name]: value }));
        } else {
            setFormData(prev => ({ ...prev, [name]: value }));
        }

        if (errors[name]) setErrors(prev => ({ ...prev, [name]: '' }));
    };

    const handleClear = () => {
        isClearingRef.current = true;
        const draftKey = getDraftStorageKey();
        localStorage.removeItem(draftKey);
        setHasDraft(false);
        lastDraftContentRef.current = '';

        setFormData({
            date: new Date().toISOString().split('T')[0],
            batch_no: '',
            barcode: '',
            product_name: '',
            product_code: '',
            category: '',
            company: '',
            color: '',
            size: '',
            packing_type: '',
            sub_packing_type: '',
            items_per_pack: '',
            unit_of_measure: '',
            cost_price_per_pack: '',
            sell_price_per_unit: '',
            total_quantity: '',
            quantity_alert: '',
            expiry_date: '',
            cost_per_unit: '',
            sell_per_pack: '',
            bquantity: '',
            purchase_type: 'packing',
            themeColor: formData.themeColor
        });
        setCategorySearchTerm('');
        setPackingTypeSearchTerm('');
        setSubPackingSearchTerm('');
        setUnitSearchTerm('');
        setColorSearchTerm('');
        setSizeSearchTerm('');
        setErrors({});
        setIsEditMode(false);
        lastProductDataRef.current = '';
        setCalculatedCostPerUnit('');
        setCalculatedSellPerPack('');
        setCalculatedBQuantity('');

        showToast('success', translations.draftCleared || 'Form cleared');

        // Refocus on product name after clearing
        setTimeout(() => {
            if (productNameRef.current) {
                productNameRef.current.focus();
            }
        }, 100);

        setTimeout(() => {
            isClearingRef.current = false;
        }, 500);
    };

    const handleSwitchShop = async (shop) => {
        try {
            const success = await switchShop(shop.shop_id, shop.shop_name, shop.shop_code);
            if (success) {
                const draftKey = getDraftStorageKey();
                localStorage.removeItem(draftKey);
                setHasDraft(false);
                setCalculatedCostPerUnit('');
                setCalculatedSellPerPack('');
                setCalculatedBQuantity('');
                setCategorySearchTerm('');
                setPackingTypeSearchTerm('');
                setSubPackingSearchTerm('');
                setUnitSearchTerm('');
                setColorSearchTerm('');
                setSizeSearchTerm('');
                lastDraftContentRef.current = '';
            }
            showToast(success ? 'success' : 'error',
                success ? (translations.shopSwitched || 'Shop switched successfully')
                    : (translations.shopSwitchFailed || 'Failed to switch shop'));
        } catch (error) {
            showToast('error', translations.shopSwitchFailed || 'Failed to switch shop');
        }
    };

    const generateBarcode = () => {
        if (!formData.batch_no || !user?.username || !currentShop) return;

        const shopPrefix = currentShop.shop_id.toString().substring(0, 2).replace(/[^0-9]/g, '0');
        const userPrefix = user.username.substring(0, 3).toUpperCase().replace(/[^A-Z0-9]/g, 'P');
        const timestamp = Date.now().toString().substring(7);
        const batchHash = btoa(formData.batch_no).substring(0, 5).replace(/[^A-Z0-9]/g, '');

        setFormData(prev => ({ ...prev, barcode: `${shopPrefix}${userPrefix}${timestamp}${batchHash}` }));
    };

    const loadProductData = async (id) => {
        if (!currentShop) {
            showToast('error', translations.selectShop || 'Please select a shop first');
            setShowShopSelector(true);
            return;
        }

        setLoading(true);
        try {
            const response = await fetch('https://ourzestapp.online/oz_backend/mechanics_module/mechanics_products.php', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                    action: 'get_record',
                    id: id,
                    username: user?.username,
                    shop_id: currentShop.shop_id
                })
            });

            const responseText = await response.text();
            
            if (!responseText || responseText.trim() === '') {
                throw new Error('Empty response from server');
            }
            
            let data;
            try {
                data = JSON.parse(responseText);
            } catch (jsonError) {
                console.error('JSON Parse Error:', responseText);
                throw new Error('Invalid JSON response from server');
            }

            if (data.status === 'success' && data.data) {
                setFormData(prev => ({
                    ...prev,
                    date: data.data.date || new Date().toISOString().split('T')[0],
                    batch_no: data.data.batch_no || '',
                    barcode: data.data.barcode || '',
                    product_name: data.data.product_name || '',
                    product_code: data.data.product_code || '',
                    category: data.data.category || '',
                    company: data.data.company || '',
                    color: data.data.color || '',
                    size: data.data.size || '',
                    packing_type: data.data.packing_type || '',
                    sub_packing_type: data.data.sub_packing_type || '',
                    items_per_pack: data.data.items_per_pack || '',
                    unit_of_measure: data.data.unit_of_measure || '',
                    cost_price_per_pack: data.data.cost_per_pack || '',
                    sell_price_per_unit: data.data.sell_price_per_unit || '',
                    total_quantity: data.data.quantity || '',
                    quantity_alert: data.data.quantity_alert || '',
                    expiry_date: data.data.expiry_date || '',
                    cost_per_unit: data.data.cost_per_unit || '',
                    sell_per_pack: data.data.sell_per_pack || '',
                    bquantity: data.data.bquantity || '',
                    themeColor: prev.themeColor
                }));
                
                // Update search terms
                const selectedCategory = categoryOptions.find(c => c.value === data.data.category);
                setCategorySearchTerm(selectedCategory ? selectedCategory.label : '');
                const selectedPackingType = packingTypes.find(p => p.value === data.data.packing_type);
                setPackingTypeSearchTerm(selectedPackingType ? (translations[selectedPackingType.label] || selectedPackingType.label) : '');
                const selectedUnit = unitsOfMeasure.find(u => u.value === data.data.unit_of_measure);
                setUnitSearchTerm(selectedUnit ? selectedUnit.label : '');
                const selectedColor = colorOptions.find(c => c.value === data.data.color);
                setColorSearchTerm(selectedColor ? selectedColor.label : '');
                const selectedSize = sizeOptions.find(s => s.value === data.data.size);
                setSizeSearchTerm(selectedSize ? selectedSize.label : '');
                
                if (data.data.cost_per_unit) setCalculatedCostPerUnit(data.data.cost_per_unit);
                if (data.data.sell_per_pack) setCalculatedSellPerPack(data.data.sell_per_pack);
                if (data.data.bquantity) setCalculatedBQuantity(data.data.bquantity);
                
                // Update last draft content
                lastDraftContentRef.current = getCurrentFormContent();
            } else {
                showToast('error', data.message || 'Failed to load product data');
            }
        } catch (error) {
            console.error('Load product error:', error);
            showToast('error', translations.networkError || 'Network error');
        } finally {
            setLoading(false);
        }
    };

    // Theme color auto-sync with gradient orbs
    const applyTheme = useCallback((color) => {
        if (!color || !/^#[0-9A-F]{6}$/i.test(color)) {
            color = '#6366f1';
        }
        document.documentElement.style.setProperty('--ozui-primary', color);
        document.documentElement.style.setProperty('--ozui-primary-dark', color);
        document.documentElement.style.setProperty('--ozui-primary-light', color);
        
        // Parse color to RGB
        let r, g, b;
        if (color.startsWith('#')) {
            r = parseInt(color.slice(1, 3), 16);
            g = parseInt(color.slice(3, 5), 16);
            b = parseInt(color.slice(5, 7), 16);
        } else {
            r = 99; g = 102; b = 241;
        }
        
        // Create or update style for gradient orbs
        let style = document.getElementById('dynamic-orb-styles-product');
        if (!style) {
            style = document.createElement('style');
            style.id = 'dynamic-orb-styles-product';
            document.head.appendChild(style);
        }
        
        style.textContent = `
                .ozui-header-bg-animation .gradient-orb.orb-1 {
                    background: radial-gradient(circle, rgba(${r}, ${g}, ${b}, 0.4) 0%, rgba(${r}, ${g}, ${b}, 0.1) 100%);
                }
                .ozui-header-bg-animation .gradient-orb.orb-2 {
                    background: radial-gradient(circle, rgba(${r}, ${g}, ${b}, 0.35) 0%, rgba(${r}, ${g}, ${b}, 0.08) 100%);
                }
                .ozui-header-bg-animation .gradient-orb.orb-3 {
                    background: radial-gradient(circle, rgba(${r}, ${g}, ${b}, 0.3) 0%, rgba(${r}, ${g}, ${b}, 0.05) 100%);
                }
                .ozui-header-bg-animation .gradient-orb.orb-4 {
                    background: radial-gradient(circle, rgba(${r}, ${g}, ${b}, 0.25) 0%, rgba(${r}, ${g}, ${b}, 0.03) 100%);
                }
                .ozui-header-bg-animation .gradient-orb.orb-5 {
                    background: radial-gradient(circle, rgba(${r}, ${g}, ${b}, 0.2) 0%, rgba(${r}, ${g}, ${b}, 0.02) 100%);
                }
            `;
        
        setCurrentThemeColor(color);
    }, []);

    useEffect(() => {
        const savedTheme = localStorage.getItem('ourzest_theme') || '#6366f1';
        applyTheme(savedTheme);
        
        const handleStorageChange = (e) => {
            if (e.key === 'ourzest_theme') {
                const newTheme = e.newValue || '#6366f1';
                applyTheme(newTheme);
            }
        };
        
        const handleThemeChanged = (event) => {
            if (event.detail && event.detail.theme) {
                applyTheme(event.detail.theme);
            }
        };
        
        window.addEventListener('storage', handleStorageChange);
        window.addEventListener('themeChanged', handleThemeChanged);
        
        const interval = setInterval(() => {
            const storedTheme = localStorage.getItem('ourzest_theme');
            if (storedTheme && storedTheme !== currentThemeColor) {
                applyTheme(storedTheme);
            }
        }, 500);
        
        return () => {
            window.removeEventListener('storage', handleStorageChange);
            window.removeEventListener('themeChanged', handleThemeChanged);
            clearInterval(interval);
        };
    }, [applyTheme, currentThemeColor]);

    // Dark mode auto-sync
    useEffect(() => {
        const syncDarkMode = () => {
            const isDarkMode = localStorage.getItem('ourzest_darkMode') === 'true';
            setDarkMode(isDarkMode);
            
            const container = document.querySelector('.ozui-container');
            if (container) {
                if (isDarkMode) {
                    container.classList.add('ozui-dark');
                } else {
                    container.classList.remove('ozui-dark');
                }
            }
            
            if (isDarkMode) {
                document.body.classList.add('ozui-dark');
                document.documentElement.classList.add('ozui-dark');
            } else {
                document.body.classList.remove('ozui-dark');
                document.documentElement.classList.remove('ozui-dark');
            }
        };
        
        syncDarkMode();
        
        const handleStorageChange = (e) => {
            if (e.key === 'ourzest_darkMode') {
                syncDarkMode();
            }
        };
        
        const handleDarkModeToggle = (event) => {
            if (event.detail) {
                const isDark = event.detail.darkMode;
                setDarkMode(isDark);
                
                const container = document.querySelector('.ozui-container');
                if (container) {
                    if (isDark) {
                        container.classList.add('ozui-dark');
                    } else {
                        container.classList.remove('ozui-dark');
                    }
                }
                
                if (isDark) {
                    document.body.classList.add('ozui-dark');
                    document.documentElement.classList.add('ozui-dark');
                } else {
                    document.body.classList.remove('ozui-dark');
                    document.documentElement.classList.remove('ozui-dark');
                }
            } else {
                syncDarkMode();
            }
        };
        
        window.addEventListener('storage', handleStorageChange);
        window.addEventListener('darkModeToggled', handleDarkModeToggle);
        
        const interval = setInterval(() => {
            const storedDarkMode = localStorage.getItem('ourzest_darkMode') === 'true';
            if (storedDarkMode !== darkMode) {
                syncDarkMode();
            }
        }, 1000);
        
        return () => {
            window.removeEventListener('storage', handleStorageChange);
            window.removeEventListener('darkModeToggled', handleDarkModeToggle);
            clearInterval(interval);
        };
    }, [darkMode]);

    // Language auto-sync
    useEffect(() => {
        const loadTranslations = async (lang) => {
            const trans = await productsTranslator.getTranslations(lang);
            setTranslations(trans);
        };
        
        const handleLanguageChange = () => {
            const lang = localStorage.getItem('ourzest_language') || 'en';
            if (lang !== currentLanguage) {
                setCurrentLanguage(lang);
                loadTranslations(lang);
            }
        };
        
        const handleCustomLanguageChange = (event) => {
            if (event.detail && event.detail.language) {
                const newLang = event.detail.language;
                if (newLang !== currentLanguage) {
                    setCurrentLanguage(newLang);
                    loadTranslations(newLang);
                }
            }
        };
        
        loadTranslations(currentLanguage);
        
        window.addEventListener('storage', handleLanguageChange);
        window.addEventListener('languageChanged', handleCustomLanguageChange);
        
        const interval = setInterval(() => {
            const storedLang = localStorage.getItem('ourzest_language') || 'en';
            if (storedLang !== currentLanguage) {
                setCurrentLanguage(storedLang);
                loadTranslations(storedLang);
            }
        }, 1000);
        
        return () => {
            window.removeEventListener('storage', handleLanguageChange);
            window.removeEventListener('languageChanged', handleCustomLanguageChange);
            clearInterval(interval);
        };
    }, [currentLanguage]);

    // RTL direction sync
    useEffect(() => {
        const isRTL = currentLanguage === 'ur' || currentLanguage === 'ar';
        const container = document.querySelector('.ozui-container');
        
        if (container) {
            if (isRTL) {
                container.classList.add('ozui-rtl');
                container.classList.remove('ozui-ltr');
            } else {
                container.classList.add('ozui-ltr');
                container.classList.remove('ozui-rtl');
            }
        }
        
        if (isRTL) {
            document.documentElement.dir = 'rtl';
            document.body.dir = 'rtl';
        } else {
            document.documentElement.dir = 'ltr';
            document.body.dir = 'ltr';
        }
    }, [currentLanguage]);

    const isRTL = currentLanguage === 'ur' || currentLanguage === 'ar';

    // Render shop indicator
    const renderShopIndicator = () => {
        if (!currentShop) {
            return (
                <div className="ozui-shop-indicator no-shop">
                    <div className="ozui-shop-badge">
                        <FontAwesomeIcon icon={faExclamationTriangle} />
                        <span className="ozui-shop-warning">
                            {translations.noShopSelected || 'No shop selected'}
                        </span>
                    </div>
                    <button
                        className="ozui-header-shop-btn"
                        onClick={() => setShowShopSelector(true)}
                    >
                        <FontAwesomeIcon icon={faExchangeAlt} />
                        <span>{translations.switchShop || 'Switch Shop'}</span>
                    </button>
                </div>
            );
        }
        
        return (
            <div className="ozui-shop-indicator">
                {/* Shop indicator content - kept empty as original */}
            </div>
        );
    };

    return (
        <div className={`ozui-container ${isRTL ? 'ozui-rtl' : 'ozui-ltr'} ${darkMode ? 'ozui-dark' : ''}`}>
            <ToastNotification toast={toast} setToast={setToast} translations={translations} />
            
            <ShopSelectorModal
                isOpen={showShopSelector}
                onClose={() => setShowShopSelector(false)}
                shops={availableShops}
                currentShop={currentShop}
                onSelectShop={handleSwitchShop}
                translations={translations}
                loading={loadingShops}
            />

            {/* Modern Animated Sticky Header */}
            <div className="ozui-sticky-header">
                <div className="ozui-header-bg-animation">
                    <div className="gradient-orb orb-1"></div>
                    <div className="gradient-orb orb-2"></div>
                    <div className="gradient-orb orb-3"></div>
                    <div className="gradient-orb orb-4"></div>
                    <div className="gradient-orb orb-5"></div>
                </div>
                <div className="ozui-header-content">
                    <div className="ozui-header-left">
                        <div className="ozui-header-title">
                            <h1>{isEditMode ? (translations.editProduct || 'Edit Stock') : (translations.addProduct || 'Add Stock')}</h1>
                            <p>{translations.fillDetails || 'Fill in the stock details below'}</p>
                        </div>
                    </div>
                    
                    <div className="ozui-header-right">
                        {renderShopIndicator()}
                        
                        <div className="ozui-header-actions">
                            <button 
                                className="ozui-action-btn clear-draft" 
                                onClick={handleClear}
                                disabled={loading}
                                title={translations.clearButton || 'Clear Form'}
                            >
                                <FontAwesomeIcon icon={faTimes} />
                                <span>{translations.clearButton || 'Clear'}</span>
                            </button>
                            
                            <button 
                                className="ozui-action-btn save-draft" 
                                onClick={() => saveDraft()}
                                disabled={loading || isEditMode}
                                title={translations.saveDraft || 'Save as Draft'}
                            >
                                <FontAwesomeIcon icon={faFileAlt} />
                                <span>{translations.saveDraft || 'Save Draft'}</span>
                            </button>
                            
                            <div className="ozui-drafts-dropdown-container" ref={draftsDropdownRef}>
                                <button 
                                    className="ozui-action-btn drafts-btn" 
                                    onClick={() => setShowDraftsList(!showDraftsList)}
                                    title={translations.viewDrafts || 'View Drafts'}
                                >
                                    <FontAwesomeIcon icon={faFileAlt} />
                                    <span>{translations.drafts || 'Drafts'}</span>
                                    {savedDrafts.length > 0 && <span className="drafts-badge">{savedDrafts.length}</span>}
                                </button>
                                
                                {showDraftsList && (
                                    <div className="ozui-drafts-dropdown">
                                        <div className="drafts-header">
                                            <h4>{translations.savedDrafts || 'Saved Drafts'}</h4>
                                            <button onClick={() => setShowDraftsList(false)}>×</button>
                                        </div>
                                        <div className="drafts-list">
                                            {savedDrafts.length === 0 ? (
                                                <div className="no-drafts">{translations.noDraftsSaved || 'No drafts saved'}</div>
                                            ) : (
                                                savedDrafts.map(draft => (
                                                    <div key={draft.id} className="draft-item">
                                                        <div className="draft-info" onClick={() => loadDraft(draft)}>
                                                            <div className="draft-name">
                                                                {draft.product_name || 'Unnamed Product'}
                                                            </div>
                                                            <div className="draft-details">
                                                                {draft.batch_no && <span>Batch: {draft.batch_no}</span>}
                                                                {draft.company && <span>{draft.company}</span>}
                                                            </div>
                                                            <div className="draft-date">
                                                                {new Date(draft.savedAt).toLocaleDateString()}
                                                            </div>
                                                        </div>
                                                        <button 
                                                            className="delete-draft-btn"
                                                            onClick={(e) => {
                                                                e.stopPropagation();
                                                                deleteDraft(draft.id);
                                                            }}
                                                        >
                                                            <FontAwesomeIcon icon={faTimes} />
                                                        </button>
                                                    </div>
                                                ))
                                            )}
                                        </div>
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <form onSubmit={handleSubmit} className="ozui-form">
                <div className="ozui-form-row">
                    {/* Date - NO auto-focus here, date is already auto-filled */}
                    <div className={`ozui-field ${errors.date ? 'ozui-error' : ''}`}>
                        <div className="ozui-input-wrapper">
                            <input
                                type="date"
                                name="date"
                                id="date"
                                value={formData.date}
                                onChange={handleChange}
                                placeholder=" "
                                disabled={loading}
                            />
                            <label htmlFor="date">
                                <FontAwesomeIcon icon={faCalendarAlt} />
                                {translations.date || 'Date'}
                            </label>
                        </div>
                    </div>

                    {/* Product Name - THIS gets auto-focus for typing */}
                    <div className={`ozui-field ${errors.product_name ? 'ozui-error' : ''}`}>
                        <div className="ozui-input-wrapper">
                            <input
                                ref={productNameRef}
                                type="text"
                                name="product_name"
                                id="product_name"
                                value={formData.product_name}
                                onChange={handleChange}
                                placeholder=" "
                                disabled={loading}
                            />
                            <label htmlFor="product_name">
                                <FontAwesomeIcon icon={faBox} />
                                {translations.productName || 'Product Name'} <span>*</span>
                            </label>
                        </div>
                        {errors.product_name && <small>{errors.product_name}</small>}
                    </div>

                    {/* Product Code */}
                    <div className={`ozui-field ${errors.product_code ? 'ozui-error' : ''}`}>
                        <div className="ozui-input-wrapper">
                            <input
                                type="text"
                                name="product_code"
                                id="product_code"
                                value={formData.product_code}
                                onChange={handleChange}
                                placeholder=" "
                                disabled={loading}
                            />
                            <label htmlFor="product_code">
                                <FontAwesomeIcon icon={faQrcode} />
                                {translations.productCode || 'Product Code'} 
                                <span>({translations.optional || 'Optional'})</span>
                            </label>
                        </div>
                        {errors.product_code && <small>{errors.product_code}</small>}
                    </div>

                    {/* Batch Number - Auto-filled from product name (6 characters now) */}
                    <div className={`ozui-field ${errors.batch_no ? 'ozui-error' : ''}`}>
                        <div className="ozui-input-wrapper">
                            <input
                                type="text"
                                name="batch_no"
                                id="batch_no"
                                value={formData.batch_no}
                                onChange={handleChange}
                                placeholder=" "
                                disabled={loading || isEditMode}
                                readOnly={!isEditMode && formData.product_name}
                                className={!isEditMode && formData.product_name ? 'auto-filled' : ''}
                            />
                            <label htmlFor="batch_no">
                                <FontAwesomeIcon icon={faTag} />
                                {translations.batchNumber || 'Batch Number'} 
                                {!isEditMode && !formData.product_name && <span className="auto-hint">(Auto from product name)</span>}
                                {!isEditMode && formData.product_name && <span className="auto-generated">(Auto-generated - 6 chars)</span>}
                            </label>
                        </div>
                        {errors.batch_no && <small>{errors.batch_no}</small>}
                    </div>

                    {/* Barcode */}
                    <div className="ozui-field">
                        <div className="ozui-input-wrapper">
                            <input
                                type="text"
                                name="barcode"
                                id="barcode"
                                value={formData.barcode}
                                readOnly
                                placeholder=" "
                                disabled
                            />
                            <label htmlFor="barcode">
                                <FontAwesomeIcon icon={faBarcode} />
                                {translations.barcode || 'Barcode'}
                            </label>
                        </div>
                    </div>

                   
                    {/* Company */}
                    <div className="ozui-field">
                        <div className="ozui-input-wrapper">
                            <input
                                type="text"
                                name="company"
                                id="company"
                                value={formData.company}
                                onChange={handleChange}
                                placeholder=" "
                                disabled={loading}
                            />
                            <label htmlFor="company">
                                <FontAwesomeIcon icon={faBuilding} />
                                {translations.company || 'Company / Brand'} 
                                <span>({translations.optional || 'Optional'})</span>
                            </label>
                        </div>
                    </div>

                    {/* Color - Manual Dropdown */}
                    <div className="ozui-field" ref={colorDropdownRef}>
                        <div className="ozui-input-wrapper ozui-category-wrapper">
                            <input
                                type="text"
                                id="color"
                                value={colorSearchTerm}
                                onChange={(e) => {
                                    setColorSearchTerm(e.target.value);
                                    setShowColorDropdown(true);
                                    if (formData.color && !colorOptions.find(c => 
                                        c.label.toLowerCase() === e.target.value.toLowerCase()
                                    )) {
                                        setFormData(prev => ({ ...prev, color: '' }));
                                    }
                                }}
                                onFocus={() => setShowColorDropdown(true)}
                                placeholder=" "
                                disabled={loading}
                                autoComplete="off"
                            />
                            <label htmlFor="color">
                                <FontAwesomeIcon icon={faTag} />
                                {translations.color || 'Color'}
                                <span>({translations.optional || 'Optional'})</span>
                            </label>
                            <FontAwesomeIcon icon={faChevronDown} className="ozui-dropdown-arrow" />
                        </div>
                        {showColorDropdown && (
                            <div className="ozui-category-dropdown">
                                {filteredColors.length > 0 ? (
                                    filteredColors.map(color => (
                                        <div
                                            key={color.value}
                                            className={`ozui-category-option ${formData.color === color.value ? 'ozui-selected' : ''}`}
                                            onClick={() => selectColor(color)}
                                        >
                                            {color.value && (
                                                <span 
                                                    style={{
                                                        display: 'inline-block',
                                                        width: '16px',
                                                        height: '16px',
                                                        borderRadius: '4px',
                                                        backgroundColor: color.value,
                                                        border: '1px solid #ddd',
                                                        marginRight: '8px'
                                                    }}
                                                />
                                            )}
                                            {color.label}
                                        </div>
                                    ))
                                ) : (
                                    <div className="ozui-category-empty">No colors found</div>
                                )}
                            </div>
                        )}
                    </div>

                    {/* Size - Manual Dropdown */}
                    <div className="ozui-field" ref={sizeDropdownRef}>
                        <div className="ozui-input-wrapper ozui-category-wrapper">
                            <input
                                type="text"
                                id="size"
                                value={sizeSearchTerm}
                                onChange={(e) => {
                                    setSizeSearchTerm(e.target.value);
                                    setShowSizeDropdown(true);
                                    if (formData.size && !sizeOptions.find(s => 
                                        s.label.toLowerCase() === e.target.value.toLowerCase()
                                    )) {
                                        setFormData(prev => ({ ...prev, size: '' }));
                                    }
                                }}
                                onFocus={() => setShowSizeDropdown(true)}
                                placeholder=" "
                                disabled={loading}
                                autoComplete="off"
                            />
                            <label htmlFor="size">
                                <FontAwesomeIcon icon={faBoxes} />
                                {translations.size || 'Size'}
                                <span>({translations.optional || 'Optional'})</span>
                            </label>
                            <FontAwesomeIcon icon={faChevronDown} className="ozui-dropdown-arrow" />
                        </div>
                        {showSizeDropdown && (
                            <div className="ozui-category-dropdown">
                                {filteredSizes.length > 0 ? (
                                    filteredSizes.map(size => (
                                        <div
                                            key={size.value}
                                            className={`ozui-category-option ${formData.size === size.value ? 'ozui-selected' : ''}`}
                                            onClick={() => selectSize(size)}
                                        >
                                            {size.label}
                                        </div>
                                    ))
                                ) : (
                                    <div className="ozui-category-empty">No sizes found</div>
                                )}
                            </div>
                        )}
                    </div>

                    {/* Packing Type - Manual Dropdown */}
                    <div className={`ozui-field ${errors.packing_type ? 'ozui-error' : ''}`} ref={packingTypeDropdownRef}>
                        <div className="ozui-input-wrapper ozui-category-wrapper">
                            <input
                                type="text"
                                id="packing_type"
                                value={packingTypeSearchTerm}
                                onChange={(e) => {
                                    setPackingTypeSearchTerm(e.target.value);
                                    setShowPackingTypeDropdown(true);
                                    if (formData.packing_type && !packingTypes.find(p => 
                                        (translations[p.label] || p.label).toLowerCase() === e.target.value.toLowerCase()
                                    )) {
                                        setFormData(prev => ({ ...prev, packing_type: '', sub_packing_type: '', items_per_pack: '', unit_of_measure: '' }));
                                        setSubPackingSearchTerm('');
                                        setUnitSearchTerm('');
                                    }
                                }}
                                onFocus={() => setShowPackingTypeDropdown(true)}
                                placeholder=" "
                                disabled={loading}
                                autoComplete="off"
                            />
                            <label htmlFor="packing_type">
                                <FontAwesomeIcon icon={faBox} />
                                {translations.packingType || 'Packing Type'} <span>*</span>
                            </label>
                            <FontAwesomeIcon icon={faChevronDown} className="ozui-dropdown-arrow" />
                        </div>
                        {errors.packing_type && <small>{errors.packing_type}</small>}
                        {showPackingTypeDropdown && (
                            <div className="ozui-category-dropdown">
                                {filteredPackingTypes.length > 0 ? (
                                    filteredPackingTypes.map(pt => (
                                        <div
                                            key={pt.value}
                                            className={`ozui-category-option ${formData.packing_type === pt.value ? 'ozui-selected' : ''}`}
                                            onClick={() => selectPackingType(pt)}
                                        >
                                            {translations[pt.label] || pt.label}
                                        </div>
                                    ))
                                ) : (
                                    <div className="ozui-category-empty">No packing types found</div>
                                )}
                            </div>
                        )}
                    </div>

                    {/* Sub Packing Type - Manual Dropdown */}
                    <div className={`ozui-field ${errors.sub_packing_type ? 'ozui-error' : ''}`} ref={subPackingDropdownRef}>
                        <div className="ozui-input-wrapper ozui-category-wrapper">
                            <input
                                type="text"
                                id="sub_packing_type"
                                value={subPackingSearchTerm}
                                onChange={(e) => {
                                    setSubPackingSearchTerm(e.target.value);
                                    setShowSubPackingDropdown(true);
                                    if (formData.sub_packing_type && !availableSubPackings.find(s => 
                                        s.label.toLowerCase() === e.target.value.toLowerCase()
                                    )) {
                                        setFormData(prev => ({ ...prev, sub_packing_type: '', items_per_pack: '', unit_of_measure: '' }));
                                        setUnitSearchTerm('');
                                    }
                                }}
                                onFocus={() => {
                                    if (formData.packing_type) {
                                        setShowSubPackingDropdown(true);
                                    }
                                }}
                                placeholder=" "
                                disabled={loading || !formData.packing_type}
                                autoComplete="off"
                            />
                            <label htmlFor="sub_packing_type">
                                <FontAwesomeIcon icon={faLayerGroup} />
                                {translations.subPackingType || 'Sub Packing Type'} <span>*</span>
                            </label>
                            <FontAwesomeIcon icon={faChevronDown} className="ozui-dropdown-arrow" />
                        </div>
                        {errors.sub_packing_type && <small>{errors.sub_packing_type}</small>}
                        {showSubPackingDropdown && formData.packing_type && (
                            <div className="ozui-category-dropdown">
                                {filteredSubPackings.length > 0 ? (
                                    filteredSubPackings.map(sub => (
                                        <div
                                            key={sub.value}
                                            className={`ozui-category-option ${formData.sub_packing_type === sub.value ? 'ozui-selected' : ''}`}
                                            onClick={() => handleSubPackingChange(sub.value, sub.label)}
                                        >
                                            {sub.label}
                                        </div>
                                    ))
                                ) : (
                                    <div className="ozui-category-empty">No sub packing types found</div>
                                )}
                            </div>
                        )}
                    </div>

                    {/* Items Per Pack */}
                    <div className={`ozui-field ${errors.items_per_pack ? 'ozui-error' : ''}`}>
                        <div className="ozui-input-wrapper">
                            <input
                                type="number"
                                name="items_per_pack"
                                id="items_per_pack"
                                value={formData.items_per_pack}
                                onChange={handleChange}
                                required
                                step="0.001"
                                min="0"
                                placeholder=" "
                                disabled={loading}
                            />
                            <label htmlFor="items_per_pack">
                                <FontAwesomeIcon icon={faCalculator} />
                                {dynamicLabels.itemsPerPackLabel} <span>*</span>
                            </label>
                        </div>
                        {errors.items_per_pack && <small>{errors.items_per_pack}</small>}
                    </div>

                    {/* Unit of Measure - Manual Dropdown */}
                    <div className={`ozui-field ${errors.unit_of_measure ? 'ozui-error' : ''}`} ref={unitDropdownRef}>
                        <div className="ozui-input-wrapper ozui-category-wrapper">
                            <input
                                type="text"
                                id="unit_of_measure"
                                value={unitSearchTerm}
                                onChange={(e) => {
                                    setUnitSearchTerm(e.target.value);
                                    setShowUnitDropdown(true);
                                    if (formData.unit_of_measure && !unitsOfMeasure.find(u => 
                                        u.label.toLowerCase() === e.target.value.toLowerCase()
                                    )) {
                                        setFormData(prev => ({ ...prev, unit_of_measure: '' }));
                                    }
                                }}
                                onFocus={() => setShowUnitDropdown(true)}
                                placeholder=" "
                                disabled={loading}
                                autoComplete="off"
                            />
                            <label htmlFor="unit_of_measure">
                                <FontAwesomeIcon icon={faBalanceScale} />
                                {translations.unitOfMeasure || 'Unit of Measure'} <span>*</span>
                            </label>
                            <FontAwesomeIcon icon={faChevronDown} className="ozui-dropdown-arrow" />
                        </div>
                        {errors.unit_of_measure && <small>{errors.unit_of_measure}</small>}
                        {showUnitDropdown && (
                            <div className="ozui-category-dropdown">
                                {filteredUnits.length > 0 ? (
                                    filteredUnits.map(unit => (
                                        <div
                                            key={unit.value}
                                            className={`ozui-category-option ${formData.unit_of_measure === unit.value ? 'ozui-selected' : ''}`}
                                            onClick={() => selectUnit(unit)}
                                        >
                                            {unit.label}
                                        </div>
                                    ))
                                ) : (
                                    <div className="ozui-category-empty">No units found</div>
                                )}
                            </div>
                        )}
                    </div>

                    {/* Cost Price Per Pack */}
                    <div className={`ozui-field ${errors.cost_price_per_pack ? 'ozui-error' : ''}`}>
                        <div className="ozui-input-wrapper">
                            <input
                                type="number"
                                name="cost_price_per_pack"
                                id="cost_price_per_pack"
                                value={formData.cost_price_per_pack}
                                onChange={handleChange}
                                required
                                step="0.01"
                                min="0"
                                placeholder=" "
                                disabled={loading}
                            />
                            <label htmlFor="cost_price_per_pack">
                                <FontAwesomeIcon icon={faRupeeSign} />
                                {dynamicLabels.costPerPackLabel} <span>*</span>
                            </label>
                        </div>
                        {errors.cost_price_per_pack && <small>{errors.cost_price_per_pack}</small>}
                    </div>

                    {/* Cost Per Unit - Read Only */}
                    <div className="ozui-field">
                        <div className="ozui-input-wrapper">
                            <input
                                type="text"
                                name="cost_per_unit"
                                id="cost_per_unit"
                                value={formData.cost_per_unit}
                                readOnly
                                placeholder=" "
                                disabled
                                className="readonly-field"
                            />
                            <label htmlFor="cost_per_unit">
                                <FontAwesomeIcon icon={faRupeeSign} />
                                {translations.costPerUnit || 'Cost per'} {formData.unit_of_measure ? getUnitDisplayLabel(formData.unit_of_measure) : 'Unit'}
                            </label>
                        </div>
                    </div>

                    {/* Sell Price Per Unit */}
                    <div className={`ozui-field ${errors.sell_price_per_unit ? 'ozui-error' : ''}`}>
                        <div className="ozui-input-wrapper">
                            <input
                                type="number"
                                name="sell_price_per_unit"
                                id="sell_price_per_unit"
                                value={formData.sell_price_per_unit}
                                onChange={handleChange}
                                required
                                step="0.01"
                                min="0"
                                placeholder=" "
                                disabled={loading}
                            />
                            <label htmlFor="sell_price_per_unit">
                                <FontAwesomeIcon icon={faRupeeSign} />
                                {translations.sellPricePerUnit || 'Sell price per'} {formData.unit_of_measure ? getUnitDisplayLabel(formData.unit_of_measure) : 'Unit'} <span>*</span>
                            </label>
                        </div>
                        {errors.sell_price_per_unit && <small>{errors.sell_price_per_unit}</small>}
                    </div>

                    {/* Selling Price Per Pack - Read Only */}
                    <div className="ozui-field">
                        <div className="ozui-input-wrapper">
                            <input
                                type="text"
                                name="sell_per_pack"
                                id="sell_per_pack"
                                value={formData.sell_per_pack}
                                readOnly
                                placeholder=" "
                                disabled
                                className="readonly-field"
                            />
                            <label htmlFor="sell_per_pack">
                                <FontAwesomeIcon icon={faRupeeSign} />
                                {dynamicLabels.sellingPerPackLabel}
                            </label>
                        </div>
                    </div>

                    {/* Total Quantity */}
                    <div className={`ozui-field ${errors.total_quantity ? 'ozui-error' : ''}`}>
                        <div className="ozui-input-wrapper">
                            <input
                                type="number"
                                name="total_quantity"
                                id="total_quantity"
                                value={formData.total_quantity}
                                onChange={handleChange}
                                required
                                step="0.001"
                                min="0"
                                placeholder=" "
                                disabled={loading}
                            />
                            <label htmlFor="total_quantity">
                                <FontAwesomeIcon icon={faWarehouse} />
                                {translations.totalQuantity || 'Total Quantity'} <span>*</span>
                            </label>
                        </div>
                        {errors.total_quantity && <small>{errors.total_quantity}</small>}
                    </div>

                    {/* Quantity Alert */}
                    <div className={`ozui-field ${errors.quantity_alert ? 'ozui-error' : ''}`}>
                        <div className="ozui-input-wrapper">
                            <input
                                type="number"
                                name="quantity_alert"
                                id="quantity_alert"
                                value={formData.quantity_alert}
                                onChange={handleChange}
                                required
                                step="0.001"
                                min="0"
                                placeholder=" "
                                disabled={loading}
                            />
                            <label htmlFor="quantity_alert">
                                <FontAwesomeIcon icon={faExclamationTriangle} />
                                {translations.quantityAlert || 'Low Stock Alert'} <span>*</span>
                            </label>
                        </div>
                        {errors.quantity_alert && <small>{errors.quantity_alert}</small>}
                    </div>

                    {/* Expiry Date */}
                    <div className={`ozui-field ${errors.expiry_date ? 'ozui-error' : ''}`}>
                        <div className="ozui-input-wrapper">
                            <input
                                type="date"
                                name="expiry_date"
                                id="expiry_date"
                                value={formData.expiry_date}
                                onChange={handleChange}
                                placeholder=" "
                                disabled={loading}
                            />
                            <label htmlFor="expiry_date">
                                <FontAwesomeIcon icon={faCalendarAlt} />
                                {translations.expiryDate || 'Expiry Date'} 
                                <span>({translations.optional || 'Optional'})</span>
                            </label>
                        </div>
                        {errors.expiry_date && <small>{errors.expiry_date}</small>}
                    </div>

                    {/* BQuantity - Read Only */}
                    <div className="ozui-field">
                        <div className="ozui-input-wrapper">
                            <input
                                type="text"
                                name="bquantity"
                                id="bquantity"
                                value={formData.bquantity}
                                readOnly
                                placeholder=" "
                                disabled
                                className="readonly-field"
                            />
                            <label htmlFor="bquantity">
                                <FontAwesomeIcon icon={faCubes} />
                                {translations.bquantity || 'BQuantity (Bulk Quantity)'}
                            </label>
                        </div>
                    </div>
                </div>
                
                {/* Form Actions */}
                <div className="ozui-form-actions">
                    <button 
                        type="submit" 
                        className="ozui-btn ozui-btn-primary" 
                        disabled={loading || !currentShop || isSubmittingRef.current}
                    >
                        {loading ? (
                            <>
                                <FontAwesomeIcon icon={faSpinner} spin />
                                <span>{isEditMode ? (translations.updating || 'Updating...') : (translations.adding || 'Adding...')}</span>
                            </>
                        ) : (
                            <>
                                <FontAwesomeIcon icon={faSave} />
                                <span>{isEditMode ? (translations.updateProduct || 'Update Product') : (translations.addProductButton || 'Save Product')}</span>
                            </>
                        )}
                    </button>
                </div>
            </form>
        </div>
    );
};

export default HardwareProduct;